<template>
  <div style="margin-top: 20px">
    <div
      style="
        display: flex;
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid black;
        background-color: #f7f7f7;
      "
    >
      <div :class="getDetailActive == 1 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          项目详细
        </div>
      </div>
      <div :class="getDetailActive == 2 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          图片展示
        </div>
      </div>
      <div :class="getDetailActive == 3 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'"
        >
          交易公告
        </div>
      </div>
      <div :class="getDetailActive == 4 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 4"
          :class="getDetailActive == 4 ? 'getDetail' : 'getdetail'"
        >
          竞买登记
        </div>
      </div>
      <div
        v-if="cityDetail.chargeStandard"
        :class="getDetailActive == 5 ? 'gettimeDetail' : ''"
      >
        <div
          @click="getDetailActive = 5"
          :class="getDetailActive == 5 ? 'getDetail' : 'getdetail'"
        >
          收费标准
        </div>
      </div>
      <div
        v-if="cityDetail.chargeStandard"
        :class="getDetailActive == 6 ? 'gettimeDetail' : ''"
      >
        <div
          @click="getDetailActive = 6"
          :class="getDetailActive == 6 ? 'getDetail' : 'getdetail'"
        >
          合同文本
        </div>
      </div>
    </div>
    <div
      style="
        text-align: center;
        padding: 20px;
        padding-top: 40px;
        font-size: 24px;
      "
      class="conent"
    >
      <div
        style="border: 1px solid #fff; margin-bottom: 30px"
        v-show="getDetailActive == 1"
      >
        <div>
          <div class="fengexian">
            <el-divider content-position="center">转出方信息</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">转出方类别:</div>
              <div class="tet2">
                {{ getDictValue(detail.economictype, "out_person_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出方名称:</div>
              <div class="tet2">
                {{ detail.outname || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">住所地址:</div>
              <div class="tet2">
                {{ detail.address || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">
                {{
                  detail.economictype == 6 || detail.economictype == 7
                    ? "身份证号"
                    : "法人身份证号"
                }}:
              </div>
              <div class="tet2">
                {{
                  (detail.idnum
                    ? detail.idnum.slice(0, 4) +
                      "**********" +
                      detail.idnum.slice(-4)
                    : "") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">联系电话:</div>
              <div class="tet2">
                <span>{{
                  (detail.phone &&
                    (showPhone
                      ? detail.phone
                      : detail.phone.slice(0, 3) +
                        "*****" +
                        detail.phone.slice(-3))) ||
                  "/"
                }}</span>
                <img
                  src="../assets/img/closeEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-if="showPhone && cityDetail.cityName != '许昌市'"
                  @click="checkShowPhone"
                />
                <img
                  src="../assets/img/openEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-else-if="detail.phone && cityDetail.cityName != '许昌市'"
                  @click="checkShowPhone"
                />
              </div>
            </div>
            <!-- <div class="tet">
              <div class="tet1">邮箱:</div>
              <div class="tet2">
                {{ detail.email || "/" }}
              </div>
            </div> -->
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">统一社会信用代码:</div>
              <div class="tet2">
                <span>{{
                  (detail.registernum &&
                    (showRegisternum
                      ? detail.registernum
                      : detail.registernum.slice(0, 4) +
                        "**********" +
                        detail.registernum.slice(-4))) ||
                  "/"
                }}</span>
                <img
                  src="../assets/img/closeEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-if="showRegisternum"
                  @click="checkShowRegisternum"
                />
                <img
                  src="../assets/img/openEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-else-if="detail.registernum"
                  @click="checkShowRegisternum"
                />
              </div>
            </div>
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">注册资本:</div>
              <div class="tet2">
                {{ detail.registermoney || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">法定代表人:</div>
              <div class="tet2">
                {{ detail.realname || "/" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="border: 1px solid #fff; margin-bottom: 30px"
        v-show="getDetailActive == 1"
      >
        <div>
          <div class="fengexian">
            <el-divider content-position="center">
              {{ detail.number == 11 ? "项目信息" : "产权信息" }}</el-divider
            >
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">项目名称:</div>
              <div class="tet2">
                {{ detail.projectname || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">坐落位置:</div>
              <div class="tet2">
                {{ detail.pid || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">预算金额(万元):</div>
              <div class="tet2">
                {{ detail.budgetAmount || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">资金来源:</div>
              <div class="tet2">
                {{ detail.amountSource || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">计划开工日期:</div>
              <div class="tet2">
                {{ detail.jobstarttime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">计划完工日期:</div>
              <div class="tet2">
                {{ detail.jobstoptime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">招标方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.invitationType, "invitation_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">数量:</div>
              <div class="tet2">
                {{ detail.area || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">单位:</div>
              <div class="tet2">
                {{ getDictValue(detail.areaUnit, "area_unit") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出金额:</div>
              <div class="tet2">
                {{
                  detail.price +
                    " 元/年/" +
                    getDictValue(detail.areaUnit, "area_unit") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">项目类型:</div>
              <div class="tet2">
                {{ getDictValue(detail.projectAreaType, "project_area_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">农地权属:</div>
              <div class="tet2">
                {{ getDictValue(detail.soil, "land_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">承包方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.job, "job_type") }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">项目概述:</div>
              <div class="tet2">
                {{ detail.content || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">地力等级:</div>
              <div class="tet2">
                {{ detail.diji || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">东邻:</div>
              <div class="tet2">
                {{ detail.east || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">南邻:</div>
              <div class="tet2">
                {{ detail.south || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">西邻:</div>
              <div class="tet2">
                {{ detail.west || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">北邻:</div>
              <div class="tet2">
                {{ detail.north || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">涉及农户数:</div>
              <div class="tet2">
                {{ detail.peasantnum || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number != 1">
              <div class="tet1">土地性质:</div>
              <div class="tet2">
                {{ getDictValue(detail.tdxz, "tdxz_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">交通:</div>
              <div class="tet2">
                {{ detail.traffic || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">地上物情况:</div>
              <div class="tet2">
                {{ detail.dswqk || "/" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="border: 1px solid #fff; margin-bottom: 30px"
        v-show="getDetailActive == 1"
      >
        <div>
          <div class="fengexian">
            <el-divider content-position="center"> 转出信息</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">转出开始时间:</div>
              <div class="tet2">
                {{ detail.outstarttime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">转出结束时间:</div>
              <div class="tet2">
                {{ detail.outstoptime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">流转期限（月）:</div>
              <div class="tet2">
                {{
                  this.detail.outstarttime &&
                  this.detail.outstoptime &&
                  (Number(this.detail.outstoptime.split("-")[0]) -
                    Number(this.detail.outstarttime.split("-")[0])) *
                    12 +
                    Number(this.detail.outstoptime.split("-")[1]) -
                    Number(this.detail.outstarttime.split("-")[1]) +
                    Number(
                      (
                        (Number(this.detail.outstoptime.split("-")[2]) -
                          Number(this.detail.outstarttime.split("-")[2])) /
                        30
                      ).toFixed(2)
                    )
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.rollout, "out_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">支付方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.payment, "pay_type") }}
              </div>
            </div>
            <div class="tet" v-if="detail.payment == 6">
              <div class="tet1">分期次数:</div>
              <div class="tet2">
                {{ detail.times || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">保证金（元）:</div>
              <div class="tet2">
                {{
                  (cityDetail.cityName != "濮阳市华龙区" &&
                    cityDetail.cityName != "濮阳市清丰县" &&
                    detail.deposit) ||
                  "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">出价幅度:</div>
              <div class="tet2">
                {{
                  getDictValue(
                    Number(detail.floatingPrice).toFixed(0),
                    "floating_price"
                  )
                }}
                元/年/{{ getDictValue(detail.areaUnit, "area_unit") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">是否再次转出:</div>
              <div class="tet2">
                {{ getDictValue(detail.twoout, "yes_no") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">上次转出方式:</div>
              <div class="tet2">
                {{ detail.oneout || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">其他农户是否放弃优先权:</div>
              <div class="tet2">
                {{ getDictValue(detail.otherpeasant, "yes_no") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">授权情况:</div>
              <div class="tet2">
                {{ detail.authorization || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">受让条件:</div>
              <div class="tet2">
                <span style="white-space: pre-wrap"
                  >自然人需年满18周岁以上、70周岁以下具有完全民事行为能力。非失信人员。</span
                >
              </div>
            </div>
            <div class="tet">
              <div class="tet1">披露事项:</div>
              <div class="tet2">
                {{ detail.cracksevents || "/" }}
              </div>
            </div>
            <!-- <div class="tet">
              <div class="tet1">公示期（天）:</div>
              <div class="tet2">
                {{ detail.expire || "/" }}
              </div>
            </div> -->
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">承包用途:</div>
              <div class="tet2">
                {{ detail.contractingpurpose || "/" }}
              </div>
            </div>
            <!-- <div class="tet">
              <div class="tet1">支付期限（天）:</div>
              <div class="tet2">
                {{ detail.paymentDateline || "/" }}
              </div>
            </div> -->
            <!-- <div class="tet">
              <div class="tet1">是否线上竞拍:</div>
              <div class="tet2">
                {{ getDictValue(detail.isOnline, "yes_no") }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div
        style="border: 1px solid #fff; margin-bottom: 30px"
        v-show="getDetailActive == 1"
      >
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易条件</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">标的公告价格:</div>
              <div class="tet2">
                {{
                  detail.price +
                    " 元/年/" +
                    getDictValue(detail.areaUnit, "area_unit") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">受让方应当具备的条件:</div>
              <div class="tet3">{{ detail.condition || "/" }}</div>
            </div>
            <div class="tet">
              <div class="tet1">合同付款支付方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.payment, "pay_type") }}
              </div>
            </div>

            <div class="tet">
              <div class="tet1">其他需要披露的事项:</div>
              <div class="tet2">{{ detail.cracksevents || "/" }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="getDetailActive == 2">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">图片展示</el-divider>
          </div>
        </div>
        <div class="imgcontent">
          <el-image
            v-for="(item, index) in detail.imgList"
            :key="index"
            style="
              width: 48%;
              height: auto;
              margin-left: 10px;
              margin-bottom: 10px;
            "
            :src="item"
            :preview-src-list="detail.imgList"
          >
          </el-image>
        </div>
      </div>
      <div
        v-if="
          (cityDetail.cityName == '濮阳市华龙区' ||
            cityDetail.cityName == '获嘉县' ||
            cityDetail.cityName == '濮阳市清丰县') &&
          getDetailActive == 3
        "
      >
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易公告</el-divider>
          </div>
        </div>
        <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            获嘉县农村产权交易公告
          </p>
          <br />
          <p style="text-indent: 2em">
            根据《获嘉县农村产权流转交易管理办法》规定，受
            <span style="text-decoration: underline">{{ detail.outname }}</span>
            的申请，获嘉县农村产权交易中心组织
            <span style="text-decoration: underline">{{
              detail.projectname
            }}</span>
            交易项目编号：
            <span style="text-decoration: underline">{{
              detail.numbering
            }}</span
            >，现将有关事项公告如下：
          </p>
          <p style="text-indent: 2em; font-weight: 700">一、项目概况</p>
          <p style="text-indent: 2em">
            {{ detail.projectname }},位置:东至{{ detail.east }}、南至{{
              detail.south
            }}、西至{{ detail.west }}、北至{{ detail.north }},数量{{
              detail.area + getDictValue(detail.areaUnit, "area_unit")
            }}。现对外{{ getDictValue(detail.rollout, "out_type") }},合同期限{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}年,起始价{{
              detail.price +
                " 元/年/" +
                getDictValue(detail.areaUnit, "area_unit") || "/"
            }}。
          </p>
          <p>{{ detail.cracksevents }}</p>
          <p style="text-indent: 2em; font-weight: 700">二、报名须知</p>
          <p style="text-indent: 2em">
            （一）报名时间： {{ detail.releaseRecord.applyStartTime }}-
            {{ detail.releaseRecord.applyStopTime }}。
          </p>
          <p style="text-indent: 2em">
            （二）意向竞价人需在获嘉县农村产权交易信息服务平台(https://www.hjxnccq.cn)注册登陆后，进行报名和竞价。
          </p>
          <p style="text-indent: 2em">
            （三）资格审核：报名信息提交后，农交中心工作人员对报名信息进行资格审核。审核通过后，方为报名成功。
          </p>
          <p style="text-indent: 2em">
            （四）意向竞价人在报名时间截止前，须采取银行转账或汇款方式交纳竞价保证金，并备注相关信息。投标保证金以到账时间为准，不计利息，超过规定时间后，视为报名失败。
          </p>
          <p style="text-indent: 2em; font-weight: 700">三、竞价方式</p>
          <p style="text-indent: 2em">
            本项目采用在线自由竞价方式，正向竞价确定成交人。在线自由竞价交易规则：
          </p>
          <p style="text-indent: 2em">
            (一)自由竞价期120分钟,在此期间内，意向竞价人可以对标的进行多次报价，每次报价不能低于当前最高有效报价，直到在竞价期内不再出现有效报价，则竞价结束。
          </p>
          <p style="text-indent: 2em">
            (二)竞价过程中，系统实时显示项目最新报价、竞价倒计时、报价次数、报价记录等信息。竞价结束后，最高出价者获得成交资格。
          </p>
          <p style="text-indent: 2em">
            (三)农交中心管理员对竞价主体、竞价过程进行监控，发现异常可以随时终止竞价，并告知所有参与方。
          </p>
          <p style="text-indent: 2em; font-weight: 700">四、交易（竞价）时间</p>
          <p style="text-indent: 2em">
            {{ detail.releaseRecord.biddingStartTime }}开始，结束时间为{{
              detail.releaseRecord.biddingStopTime
            }}结束，竞价时间不足5分钟时，每次出价后剩余竞价时间会延长到5分钟，直至无人出价。
          </p>
          <p style="text-indent: 2em; font-weight: 700">五、标的咨询</p>
          <p style="text-indent: 2em">即日起接受咨询，自行看样。</p>
          <p style="text-indent: 2em">
            项目联系人：<span style="text-decoration: underline">{{
              detail.realname
            }}</span>
            联系电话：<span style="text-decoration: underline">{{
              detail.phone
            }}</span>
          </p>
          <p style="text-indent: 2em">
            意向竞价人应向项目联系人咨询，自行到项目现场查勘，充分了解项目现状,并依据周围环境等因素综合考虑参与竞价。如竞价人忽略此项提醒，风险自担。
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、注意事项</p>
          <p style="text-indent: 2em">(一)首次参与线上交易注意事项：</p>
          <p style="text-indent: 2em">
            1、本项目采用在线自由竞价，意向竞价人请务必确认已在网上平台(https://www.hjxnccq.cn)注册交易账号，且账号已完成实名注册。
          </p>
          <p style="text-indent: 2em">
            2、根据本项目《交易公告》要求，意向竞价人需在报名时间截止前交纳保证金，以免影响参与资格。
          </p>
          <p style="text-indent: 2em">
            3、意向竞价人应根据项目公告中的竞价规则进行报价。
          </p>
          <p style="text-indent: 2em">
            (二)在项目交易过程中，如发现围标、串标等违法违规行为，其保证金予以没收。
          </p>
          <p style="text-indent: 2em">
            (三)本项目成交后，未成交者的保证金在交易结束后5日内退还(不计利息)。
          </p>
          <p style="text-indent: 2em">
            (四)意向竞价人应通过电脑或手机App按时上线交易，但要确保网络环境良好。
          </p>
          <p style="text-indent: 2em">
            (五)产权四至及其他事项解释权归项目发包方所有。
          </p>
          <p style="text-indent: 2em; font-weight: 700">七、项目交易组织方</p>
          <p style="text-indent: 2em">
            获嘉县农村产权交易中心，联系电话：4562910。
          </p>
          <br />
          <br />
          <p style="text-align: right">
            {{ cityDetail.cityName }}农村产权交易中心
          </p>
          <p style="text-align: right">____________年______月______日</p>
        </div>
      </div>
      <div v-show="getDetailActive == 4">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">竞买登记</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>投标方资格条件</th>
            <td></td>
          </tr>
          <tr>
            <th>报名方式</th>
            <td v-if="!applyWay">
              <p>1、意向受让方首次报名须知：</p>
              <p>
                ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
              </p>
              <p>
                ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
              </p>
              <p>
                2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
              </p>
              <p>3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。</p>
              <p>
                4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
              </p>
            </td>
            <td v-else v-html="applyWay"></td>
          </tr>
          <tr>
            <th>保证金及处理方式</th>
            <td>
              <p style="font-weight: bold">
                1、须交纳的交易保证金金额为人民币{{
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? detail.deposit + " 元"
                    : ""
                }}。
              </p>
              <p style="font-weight: bold">
                2、开户行:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.bankName
                    : ""
                }}
              </p>
              <p style="font-weight: bold">
                户名:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.cardName
                    : ""
                }}
              </p>
              <p style="font-weight: bold">
                账号:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.cardNo
                    : ""
                }}
              </p>
              <p>
                须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
              </p>
              <p>交纳交易保证金要求：</p>
              <p>
                ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
              </p>
              <p>② 交纳交易保证金时，须备注相关信息：</p>
              <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
              <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
              <p>
                交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
              </p>
              <p>
                未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
              </p>
              <p>
                ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
              </p>
              <p>
                ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div v-show="cityDetail.chargeStandard && getDetailActive == 5">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">收费标准</el-divider>
          </div>
        </div>
        <div
          style="text-align: left; display: block"
          v-html="chargeStandard"
        ></div>
      </div>
      <div style="border: 1px solid #fff" v-show="getDetailActive == 6">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">合同文本</el-divider>
          </div>
        </div>
        <!-- t2.docx 转让 -->
        <div
          class="hetongBox"
          v-if="getDictValue(detail.rollout, 'out_type') == '转让'"
        >
          <p style="text-align: center">转让合同</p>
          <p>
            甲方（转让人）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">法定代表人：_________________</p>
            <p style="width: 50%">职务：_________________</p>
          </div>
          <p>
            或身份证号码：<span style="text-decoration: underline">{{
              detail.idnum
            }}</span>
          </p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">委托代理人：_________________</p>
            <p style="width: 50%">身份证号码：_________________</p>
          </div>
          <p>
            通讯地址：<span style="text-decoration: underline">{{
              detail.address
            }}</span>
          </p>
          <p>
            电话：<span style="text-decoration: underline">{{
              detail.phone
            }}</span>
          </p>
          <br />
          <p>乙方（受让人）：_________________</p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">法定代表人：_________________</p>
            <p style="width: 50%">职务：_________________</p>
          </div>
          <p>
            或身份证号码：<span>________________________________________</span>
          </p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">委托代理人：_________________</p>
            <p style="width: 50%">身份证号码：_________________</p>
          </div>
          <p>通讯地址：<span>________________________________________</span></p>
          <p>电话：<span>________________________________________</span></p>
          <br />
          <p style="text-indent: 2em">
            甲乙双方根据《中华人民共和国合同法》等相关法律规定，本着精诚合作、互利共赢的原则，就转让事宜自愿达成如下条款，以兹遵守。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第一条 转让标的及权利
          </p>
          <p style="text-indent: 2em">
            1.1“转让标的”系指由甲方确认向乙方转让的下列标的：___________________________________________________________。
          </p>
          <p style="text-indent: 2em">1.2甲方交付的标的不得含有以下内容：</p>
          <p style="text-indent: 2em">（1）反对宪法确定的基本原则的；</p>
          <p style="text-indent: 2em">（2）危害国家统一、主权和领土完整的；</p>
          <p style="text-indent: 2em">
            （3）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
          </p>
          <p style="text-indent: 2em">
            （4）法律、行政法规和国家规定禁止的其他内容的。
          </p>
          <br />
          <p style="font-weight: 700; text-indent: 2em">
            第二条 转让费用及支付方式
          </p>
          <p style="text-indent: 2em">
            2.1乙方采取下述第____种方式向甲方支付本合同转让费用。
          </p>
          <p style="text-indent: 2em">
            （1）一次性支付转让费人民币________ 元，付费时间为__________________________________________________________________
          </p>
          <p style="text-indent: 2em">
            （2）乙方分期向甲方支付转让费人民币________ 元，分期支付方式为________________________________________________
          </p>
          <p style="text-indent: 2em">
            （3）其他支付方式：_________________________________________________________________________________________________
          </p>
          <p style="text-indent: 2em">
            2.2乙方应按上述约定按时足额将属于甲方的转让费用支付至甲方指定账户，账户信息如下：
          </p>
          <p style="text-indent: 2em">
            开户行：________________________________________________
          </p>
          <p style="text-indent: 2em">
            户名：__________________________________________________
          </p>
          <p style="text-indent: 2em">
            账号：__________________________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">第三条 转让期限</p>
          <p style="text-indent: 2em">
            本合同项下权利转让期限为
            <span style="text-decoration: underline"
              >{{
                this.detail.outstarttime &&
                this.detail.outstoptime &&
                (
                  ((Number(this.detail.outstoptime.split("-")[0]) -
                    Number(this.detail.outstarttime.split("-")[0])) *
                    12 +
                    Number(this.detail.outstoptime.split("-")[1]) -
                    Number(this.detail.outstarttime.split("-")[1]) +
                    Number(
                      (
                        (Number(this.detail.outstoptime.split("-")[2]) -
                          Number(this.detail.outstarttime.split("-")[2])) /
                        30
                      ).toFixed(2)
                    )) /
                  12
                ).toFixed(2)
              }} </span
            >年，自
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            至
            <span style="text-decoration: underline">
              {{ detail.outstoptime }}</span
            >
            。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第四条 双方其他权利与义务
          </p>
          <p style="text-indent: 2em">
            本合同生效后____日内，甲方应向乙方提供其标的，乙方向甲方支付相关约定费用。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第五条 违约责任</p>
          <p style="text-indent: 2em">
            除另有约定外，乙方逾期支付甲方转让费用的，每逾期一日，乙方应按应付未付金额的千分之_____向甲方支付违约金，逾期超过____日，甲方有权解除本合同。
          </p>
          <p style="text-indent: 2em">
            除本合同另有约定外，乙方违反本合同的约定，经甲方提出，不在甲方规定的时间内纠正其违约行为的，甲方有权解除本合同。
          </p>
          <p style="text-indent: 2em">
            除另有约定外，甲方违反本合同的约定，经乙方提出，不在乙方规定的时间内纠正其违约行为的，乙方有权解除本合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第六条 税费</p>
          <p style="text-indent: 2em">
            本合同双方应遵守中国法律法规之规定，照章纳税。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第七条 合同变更</p>
          <p style="text-indent: 2em">
            经双方协商一致，可签订书面协议对本合同进行变更，该书面协议作为本合同的组成部分，与本合同具有同等法律效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第八条 合同终止</p>
          <p style="text-indent: 2em">存在下列情形之一时，本合同终止：</p>
          <p style="text-indent: 2em">（1）因不可抗力导致本合同无法执行时；</p>
          <p style="text-indent: 2em">（2）本合同履行完毕；</p>
          <p style="text-indent: 2em">（3）双方协商一致解除本合同的；</p>
          <p style="text-indent: 2em">（4）依据本合同单方解除本合同的；</p>
          <p style="text-indent: 2em">
            （5）__________________________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条 不可抗力</p>
          <p style="text-indent: 2em">
            1、本合同所称不可抗力是指在合同履行期间发生的合同当事人不能预见、不能避免和不能克服的客观情况。不可抗力可以是自然原因酿成的，或是人为的、社会因素引起的，也可以是意外事件。如地震、水灾、旱灾、战争、政府禁令、罢工、车祸等。
          </p>
          <p style="text-indent: 2em">
            2、如因不可抗力事件的发生导致合同无法履行时，遇不可抗力的一方应及时将事故情况告知另一方，并应在______天内，提供事故详情及合同不能履行或者需要延期履行的书面资料，双方认可后协商终止合同或暂时延迟合同的履行。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 通知</p>
          <p style="text-indent: 2em">
            1、根据本合同需要发出的全部通知以及双方的往来文件及与本合同有关的通知和要求等，必须用书面形式，可采用书信、快递、当面送交等方式传递。
          </p>
          <p style="text-indent: 2em">
            2、甲、乙双方承诺以本合同首部的通讯地址、联系方式为有效通讯地址、联系方式；本合同首部的通讯地址、联系方式变更的，变更方应及时通知对方，否则，应当自行承担由此造成的一切不利后果。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条 争议解决</p>
          <p style="text-indent: 2em">
            双方在履行合同中发生争议的，应协商解决；协商不成的，可依法提起诉讼。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十二条 合同生效</p>
          <p style="text-indent: 2em">
            本合同自双方签订之日起生效，本合同一式两份，双方各执一份，每份具有同等法律效力。
          </p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">甲方：___________</p>
            <p style="width: 50%">乙方：___________</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">法定代表人/委托代理人：___________</p>
            <p style="width: 50%">法定代表人/委托代理人：___________</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">__________年_____月_____日</p>
            <p style="width: 50%">__________年_____月_____日</p>
          </div>
        </div>
        <!-- s1.docx 土地经营权&&获嘉县 -->
        <div
          class="hetongBox"
          v-else-if="
            cityDetail.cityName == '获嘉县' &&
            (getOutPorjectType(detail.number) == '土地经营权' ||
              getOutPorjectType(detail.number) == '农村承包土地经营权')
          "
        >
          <p>
            甲方（出租方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>机构代码：___________________________</p>
          <p>乙方（承租方）：___________________________</p>
          <p>身份证号：___________________________</p>
          <p style="text-indent: 2em">
            为切实维护土地经营权租赁双方合法利益，根据《中华人民共和国农村土地承包法》、《中华人民共和国合同法》等法律法规的规定，经甲乙双方共同协商，达成如下合同条款，双方应共同遵守。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            一、租赁土地面积和位置
          </p>
          <p style="text-indent: 2em">
            甲方自愿将位于<span style="text-decoration: underline">{{
              detail.address
            }}</span
            >,面积<span style="text-decoration: underline">{{
              detail.area
            }}</span>
            {{
              getDictValue(detail.areaUnit, "area_unit")
            }}，使用性质为__________________（地块东至
            <span style="text-decoration: underline">{{ detail.east }}</span>
            南至
            <span style="text-decoration: underline">{{ detail.south }}</span>
            西至
            <span style="text-decoration: underline">{{ detail.west }}</span>
            北至
            <span style="text-decoration: underline">{{ detail.north }}</span>
            ）<span>{{ getDictValue(detail.rollout, "out_type") }}</span
            >给乙方，用于______________。
          </p>
          <p style="text-indent: 2em; font-weight: 700">二、土地租赁期限</p>
          <p style="text-indent: 2em">
            自<span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span
            >起至<span style="text-decoration: underline">{{
              detail.outstoptime
            }}</span
            >止。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            三、租赁费约定及交款方式
          </p>
          <p style="text-indent: 2em">
            1.双方约定，乙方每年向甲方支付租赁费为每{{
              getDictValue(detail.areaUnit, "area_unit")
            }}每年<span style="text-decoration: underline"
              >¥{{ detail.dealAmount || detail.price }}</span
            >元，一年<span style="text-decoration: underline"
              >¥{{ detail.deposit }}</span
            >元大写<span style="text-decoration: underline">{{
              bigWrite(detail.deposit)
            }}</span
            >。<span style="text-decoration: underline">{{
              Math.floor(
                (this.detail.outstarttime &&
                  this.detail.outstoptime &&
                  (Number(this.detail.outstoptime.split("-")[0]) -
                    Number(this.detail.outstarttime.split("-")[0])) *
                    12 +
                    Number(this.detail.outstoptime.split("-")[1]) -
                    Number(this.detail.outstarttime.split("-")[1]) +
                    Number(
                      (
                        (Number(this.detail.outstoptime.split("-")[2]) -
                          Number(this.detail.outstarttime.split("-")[2])) /
                        30
                      ).toFixed(2)
                    )) / 12
              )
            }}</span
            >年总计____________________元 大写________________________。
          </p>
          <p style="text-indent: 2em">
            2.交款时间：乙方必须在每年的______月______日之前一次性交纳次年的租赁费¥____________________元，逾期将每天按当年的租赁费总价收取1%的滞纳金。
          </p>
          <p style="text-indent: 2em; font-weight: 700">四、双方的权利和义务</p>
          <p style="text-indent: 2em">1.甲方的权利和义务</p>
          <p style="text-indent: 2em">（1）按合同约定收取土地租赁费。</p>
          <p style="text-indent: 2em">
            （2）甲方有权要求乙方在租赁期结束后，消除不利于土地再次租赁的因素（清除地表附属物等）。
          </p>
          <p style="text-indent: 2em">
            （3）甲方有义务维护乙方在租赁期限内的合法权益。
          </p>
          <p style="text-indent: 2em">
            （4）乙方不按期交纳租赁费，甲方有权终止合同。
          </p>
          <p style="text-indent: 2em">2.乙方的权利和义务</p>
          <p style="text-indent: 2em">
            （1）乙方应依照合同约定，按时交纳土地租赁费。
          </p>
          <p style="text-indent: 2em">
            （2）乙方有义务服从甲方的领导做好秸秆禁烧、防火、环境整治等各项工作。乙方有义务保障其人身和财产安全，合同期内如发生人身和财产安全事故，由乙方自行承担责任。
          </p>
          <p style="text-indent: 2em">
            （3）合同期内，乙方无权转让土地租赁权，如需转包需经征求甲方书面同意，乙方子、女有权利继承，不能因为所有人的变动而解除合同。
          </p>
          <p style="text-indent: 2em">
            （4）合同期内，如有国家和集体建设需占用乙方所租赁土地，合同自行终止，乙方无条件退回土地。并无条件清除所租赁土地上的所有附属物。
          </p>
          <p style="text-indent: 2em">
            （5）合同期内，未经甲方乡镇人民政府书面同意，乙方不得在租赁土地上取土、种植树木、建房和其他方式改变土地性质。
          </p>
          <p style="text-indent: 2em">
            （6）合同期满后，在同等条件下，乙方可优先继续租赁。
          </p>
          <p style="text-indent: 2em; font-weight: 700">五、违约责任</p>
          <p style="text-indent: 2em">
            （1）由于一方违约终止合同，给对方造成的经济损失，应有违约方承担全部赔偿责任。
          </p>
          <p style="text-indent: 2em">
            （2）当事人一方由于法律规定的“不可抗力”的原因，不能履行合同时，应及时与对方协商，并可根据情况，部分或全部免于承担违约责任。
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、其他</p>
          <p style="text-indent: 2em">
            （1）本合同如有未尽事宜，由双方共同协商做出补充规定，补充规定与本合同具有同等效力。
          </p>
          <p style="text-indent: 2em">
            （2）此合同一式三份，甲乙双方各持一份，报送乡镇人民政府农办备案一份。
          </p>
          <p style="text-indent: 2em">（3）本合同经双方签字按手印后生效。</p>
          <br />
          <p style="text-indent: 2em">甲&nbsp;&nbsp;&nbsp;方（盖章）：</p>
          <p style="text-indent: 2em">法定代表人或委托人（签字）：</p>
          <br />
          <p style="text-indent: 2em">乙&nbsp;&nbsp;&nbsp;方（签字按手印）：</p>
          <br />
          <p style="text-indent: 2em; text-align: right">
            签订日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
          </p>
        </div>
        <!-- c1.docx 土地经营权 -->
        <div
          class="hetongBox"
          v-else-if="
            getOutPorjectType(detail.number) == '土地经营权' ||
            getOutPorjectType(detail.number) == '农村承包土地经营权'
          "
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村土地经营权流转合同
          </p>
          <p style="font-size: 22px; text-align: center">
            （本合同适用于农户流转土地经营权/农户委托村集体经济组织流转土地经营权/村集体经济组织流转机动地、新开垦耕地）
          </p>
          <br />
          <p>
            出租人(以下简称甲方)：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            承租人(以下简称乙方)：<span
              >________________________________________</span
            >
          </p>
          <p style="text-indent: 2em">
            根据《中华人民共和国合同法》、《中华人民共和国物权法》、《中华人民共和国农村土地承包法》、《中华人民共和国农村土地承包经营纠纷调解仲裁法》等法律、法规和国家有关政策的规定，本着平等、自愿、公平、诚信的原则，经甲乙双方协商一致，订立本合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第一条 流转土地经营权基本情况、流转方式与用途
          </p>
          <p>
            甲方（或受_____等_____户农户的委托）将
            <span style="text-decoration: underline">{{ detail.area }}</span>
            亩承包土地（机动地/新开垦耕地）（详见流转土地经营权基本情况表），通过
            农村综合产权交易中心
            （自行/农村综合产权交易中心。注：农户流转土地经营权可自行流转，也可通过农村综合产权交易中心流转；农户委托村集体经济组织流转土地经营权或村集体经济组织流转机动地、新开垦耕地应通过农村综合产权流转交易中心流转）以
            <span style="text-decoration: underline">
              {{ getDictValue(detail.rollout, "out_type") }}</span
            >
            （出租/入股/其他）方式流转给乙方，从事_____生产经营。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第二条 流转期限和交付时间
          </p>
          <p style="text-indent: 2em">
            土地经营权流转期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，自
            <span style="text-decoration: underline">
              {{ detail.outstarttime }}
            </span>
            起至
            <span style="text-decoration: underline">
              {{ detail.outstoptime }}</span
            >
            止。
          </p>
          <p style="text-indent: 2em">
            甲方应于______年_____月_____日之前将流转土地交付乙方。法律或行政法规要求流转土地经营权备案的，甲乙双方应于
            ______年_____月_____日前提交备案材料。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第三条 流转价款与支付方式
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            A.若采取出租（转包）或其他方式流转土地经营权，流转价款按下列第
            种方式支付：
          </p>
          <p style="text-indent: 2em">
            1.实物折合流转费用结算方式。乙方须于______（当/前一）______年_____月_____日前按每亩_____斤_____（小麦/稻谷/其他实物等）的_____（市场价/当地政府收购指导价）为标准，折合成货币向甲方支付当年流转费用。
          </p>
          <p style="text-indent: 2em">
            2.货币分期支付方式。流转费用按照_____元/亩标准计算，合计_____元/年。乙方须于_____（当/前一）______年_____月_____日前支付当年流转费用。
          </p>
          <p style="text-indent: 2em">
            （或：第一次支付：乙方于______年_____月_____日前支付给甲方________；
          </p>
          <p style="text-indent: 2em">
            第二次支付：乙方于______年_____月_____日前支付给甲方________；
          </p>
          <p style="text-indent: 2em">
            第三次支付：乙方于______年_____月_____日前支付给甲方________；）
          </p>
          <p style="text-indent: 2em">
            3.货币一次性付款方式。流转费用按________元/亩·年计算，共计____元。乙方须于______年_____月_____日前支付全部流转费用。
          </p>
          <p style="text-indent: 2em">
            4.其他支付方式：________________________________。
          </p>
          <p style="text-indent: 2em">
            5.流转费用变动：________________________________。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            B.若采取入股方式流转土地经营权，则按下列第__种方式分配股份红利：
          </p>
          <p style="text-indent: 2em">
            1.保底分红，以实物折合现金方式支付：按照每亩每年保底分配____公斤____（小麦/稻谷/其他实物等）的标准，以____（当年/上年）____（市场价/当地政府收购指导价）折合现金支付。保底分配后如有盈余部分按____________比例分配现金。
          </p>
          <p style="text-indent: 2em">
            2.保底分红，以现金方式支付：第____个生产年度乙方按照每亩________元（大写：________）的标准给予甲方保底分配。以后每年由乙方召开____________大会讨论决定保底分配标准。保底分配后如有盈余部分按以下比例分配现金：____________。
          </p>
          <p style="text-indent: 2em">
            3.不保底分红。具体方式为：____________。
          </p>
          <p style="text-indent: 2em">
            4.分红支付时间：乙方于每年____月____日之前向甲方支付保底分配部分；____（当/次）年____月____日之前支付盈余分配部分。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第四条 甲方的权利和义务
          </p>
          <p style="text-indent: 2em">1.甲方的权利</p>
          <p style="text-indent: 2em">
            ①有权监督乙方按合同约定依法利用和保护该流转土地；
          </p>
          <p style="text-indent: 2em">②有权在本合同到期后收回该流转土地；</p>
          <p style="text-indent: 2em">
            ③该流转土地被依法征收、征用、占用的，有权获得______补偿。
          </p>
          <p style="text-indent: 2em">
            ④乙方无正当理由未支付或者延迟支付流转价款的，甲方可以要求乙方在合理期限内支付。经催告后，在合理期限内乙方仍未支付的，甲方可以解除合同。
          </p>
          <p style="text-indent: 2em">2.甲方的义务</p>
          <p style="text-indent: 2em">①按时交付约定流转的土地；</p>
          <p style="text-indent: 2em">
            ②确认该流转土地权属合法、清晰，无任何与该流转土地有关的权属纠纷和经济纠纷；
          </p>
          <p style="text-indent: 2em">
            ③协助乙方处理涉及该流转土地的用路、用水、用电等纠纷；
          </p>
          <p style="text-indent: 2em">
            ④不得干涉和妨碍乙方依法进行的正常生产经营活动。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第五条 乙方的权利和义务
          </p>
          <p style="text-indent: 2em">1.乙方的权利</p>
          <p style="text-indent: 2em">
            ①有权要求甲方按合同约定交付该流转土地，并依法自主经营、处置产品、获得收益；
          </p>
          <p style="text-indent: 2em">
            ②有权利用该流转土地上已有的开展农业生产所必需的水系、道路、构筑物等设施；
          </p>
          <p style="text-indent: 2em">
            ③合同到期后，有权在同等条件下优先续约；
            该流转土地被依法征收、征用、占用的，乙方应服从，但有权获得____________补偿。
          </p>
          <p style="text-indent: 2em">2.乙方的义务</p>
          <p style="text-indent: 2em">
            ①按合同约定及时接收该流转土地并向甲方足额支付流转费用；
          </p>
          <p style="text-indent: 2em">
            ②本合同到期，应提前一个月告知甲方是否继续流转。不继续流转的，应于合同到期日交回该流转土地；
          </p>
          <p style="text-indent: 2em">③配合做好土地经营权流转审查备案工作；</p>
          <p style="text-indent: 2em">
            ④负责地上设施的维护和维修，合同到期后完整交付；
          </p>
          <p style="text-indent: 2em">
            ⑤为提高土地生产能力而进行设施改建，应征得甲方同意，需报有关部门批准的，按照相关规定办理；
          </p>
          <p style="text-indent: 2em">
            ⑥妥善管理该流转土地上未列入合同的水系、道路、构筑物等设施，如需使用或变动，须征得甲方和发包方同意；
          </p>
          <p style="text-indent: 2em">
            ⑦在法律法规政策和合同约定允许范围内保护和合理利用流转土地，不得破坏农业综合生产能力和农业生态环境，不得撂荒土地、不得用于非农建设、不得擅自改变土地用途、不得给土地造成永久性损害。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第六条 交付时和合同到期后地上附着物及相关设施的处理
          </p>
          <p style="text-indent: 2em">
            1.签订本合同并交付土地时，地上附着物及相关设施有：__________________________________________________
            。
          </p>
          <p style="text-indent: 2em">
            2.合同到期时，由国家或地方财政直接补助形成的财产按国家和天津市有关规定处理。
          </p>
          <p style="text-indent: 2em">
            3.乙方经营期间利用除财政补助外的资金构建的地上附着物及相关设备设施按下列方式处理：______________________
            。
          </p>
          <p style="text-indent: 2em">
            4.合同到期土地恢复原状等事项的处理：______________ 。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第七条 合同变更或解除
          </p>
          <p style="text-indent: 2em">
            1.经协商一致，甲乙双方可对本合同进行变更或解除。
          </p>
          <p style="text-indent: 2em">
            2.当事人一方中途变更或解除合同的，应提前________日书面通知对方。
          </p>
          <p style="text-indent: 2em">
            3.合同有效期内，因不可抗力导致合同无法继续履行的，当事人可以解除合同；双方应按合同解除日期，结清合同履行期间相关费用。
          </p>
          <p style="text-indent: 2em">
            4.当事人一方违约导致合同无法履行的，另一方可以解除合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第八条 违约责任</p>
          <p style="text-indent: 2em">
            1.因一方当事人变更或解除合同使另一方遭受损失的，除依法可免除责任的情形外，应向守约方支付违约金______
            元。如果违约金不足以弥补守约方经济损失，违约方应据实赔偿。
          </p>
          <p style="text-indent: 2em">
            2.甲方逾期交付流转土地，每延迟一天，按流转费用的____%承担违约金。
          </p>
          <p style="text-indent: 2em">
            3.乙方逾期支付流转费用，每延迟一天，按应支付费用的____%承担违约金。
          </p>
          <p style="text-indent: 2em">
            4.甲方非法干预乙方生产经营活动，给乙方造成损失的，应予以赔偿。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第九条 纠纷解决方式</p>
          <p style="text-indent: 2em">
            甲乙双方发生纠纷，可以协商解决，也可以采取调解解决。若农户流转土地经营权，可以请求村民委员会（村集体经济组织）、乡（镇）人民政府调解；若农户委托村集体经济组织流转土地经营权或村集体经济组织流转机动地、新开垦耕地，可以请求乡（镇）人民政府调解。当事人不愿协商、调解或者协商、调解不成的，可以向农村土地承包仲裁机构申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第十条 其他约定</p>
          <p style="text-indent: 2em">
            1.同意乙方依法依规开展以下__________事项。
          </p>
          <p style="text-indent: 2em">①改良土壤；</p>
          <p style="text-indent: 2em">②建设农业生产附属、配套设施；</p>
          <p style="text-indent: 2em">③以土地经营权融资担保；</p>
          <p style="text-indent: 2em">④再次流转土地经营权。</p>
          <p style="text-indent: 2em">
            2.耕地地力保护补贴以及其他政策性补贴，按国家有关规定执行。
          </p>
          <p style="text-indent: 2em">
            3.对整村土地经营权流转或500亩以上土地经营权流转等风险较高的项目，乙方应于本合同签订之日起____日内向甲方支付____元作为农村土地经营权流转风险保障金。风险保障金应专户储存，专款专用。对于擅自改变流转土地的农业用途、给土地造成严重损害或者严重破坏土地生态环境的，风险保障金不予退还。
          </p>
          <p style="text-indent: 2em">
            4.其他事项：______________________________________。
          </p>
          <p style="text-indent: 2em">
            5.本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="font-weight: 700">甲方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：{{ detail.outname }}
          </p>
          <p>身份证号 （统一社会信用代码）：{{ detail.idnum }}</p>
          <p>联系方式：{{ detail.phone }}</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ detail.address }}
          </p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乙方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：____________________________________
          </p>
          <p>身份证号 （统一社会信用代码）：________________________</p>
          <p>联系方式：_______________</p>
          <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：_______________</p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乡镇农村综合产权交易服务站备案意见</p>
          <p>备案人：______________________</p>
          <p>备案日期：________年____月____日</p>
          <br />
          <p style="font-weight: 700">
            鉴 证 方（签字/签章）：{{ cityDetail.cityName }}农村综合产权交易中心
          </p>
          <P
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：____________________________________________</P
          >
          <P>联系方式：____________________________________________</P>
          <P>鉴证日期：________年____月____日</P>
          <P style="text-indent: 2em">合同附件：</P>
          <P style="font-weight: 700; text-align: center"
            >流转土地经营权基本情况表</P
          >
          <br />
          <table border="1">
            <tr>
              <th style="width: 100px" rowspan="3">序号</th>
              <th rowspan="3">委托人（承包方代表）</th>
              <th rowspan="3">地块名称</th>
              <th rowspan="3">地块编码</th>
              <th rowspan="3">面积（亩）</th>
              <td colspan="4" rowspan="1" style="text-align: center">
                四至界限
              </td>
              <th rowspan="3">土地承包经营权证或承包合同编号</th>
            </tr>
            <tr>
              <th rowspan="2">东</th>
              <th rowspan="2">南</th>
              <th rowspan="2">西</th>
              <th rowspan="2">北</th>
            </tr>
            <tr></tr>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>3</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="10">......</td>
            </tr>
            <tr>
              <td>合计</td>
              <td colspan="9">
                农户________户、地块________块、面积________亩。
              </td>
            </tr>
          </table>
        </div>
        <!-- c2.docx 四荒 -->
        <div
          class="hetongBox"
          v-else-if="getOutPorjectType(detail.number) == '四荒'"
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村集体资源性资产（四荒地）承包合同
          </p>
          <p style="font-size: 22px; text-align: center">
            （本合同适用于村集体经济组织发包荒山、荒沟、荒丘、荒滩时使用）
          </p>
          <br />
          <p>
            发包方（以下简称甲方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            承包方（以下简称乙方）：<span
              >________________________________________</span
            >
          </p>
          <p style="text-indent: 2em">
            为维护承包双方当事人的合法权益，根据《中华人民共和国合同法》、《中华人民共和国物权法》、《中华人民共和国农村土地承包法》、《中华人民共和国农村土地承包经营纠纷调解仲裁法》等法律、法规和国家有关政策规定以及本集体经济组织依法通过的农村集体资源性资产发包方案，甲乙双方本着平等、自愿、公平、诚信的原则，经双方协商一致，订立本合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第一条 集体资源性资产基本情况与用途
          </p>
          <p style="text-indent: 2em">
            甲方将位于______________占地总面积为
            <span style="text-decoration: underline">{{ detail.area }}</span>
            亩的四荒地（详见资源性资产基本情况表）通过__
            农村综合产权交易中心以__拍卖__（招标/拍卖/公开协商）方式承包给乙方，从事______
            生产经营。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第二条 承包期限和交付时间
          </p>
          <p style="text-indent: 2em">
            承包期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，自
            <span style="text-decoration: underline">
              {{ detail.outstarttime }}
            </span>
            起至
            <span style="text-decoration: underline">
              {{ detail.outstoptime }}</span
            >
            止。
          </p>
          <p style="text-indent: 2em">
            甲方应于______年__ 月__ 日之前将该四荒地交付乙方。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第三条 承包费用与支付方式
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            承包费用按下列第__ 种方式计算：
          </p>
          <p style="text-indent: 2em">
            1.实物计费货币结算方式。乙方须于________ （当/前一）年__ 月__
            日前按每亩______斤______（小麦/稻谷/其他实物）的______________
            （市场价/当地政府收购指导价）为标准，折合成货币向甲方支付当年承包费。
          </p>
          <p style="text-indent: 2em">
            2.货币计费分期支付方式。承包费按照______元/亩标准计算，合计______元/年。乙方须于______年__
            月__ 日前支付当年承包费。
          </p>
          <p style="text-indent: 2em">
            （或：第一次支付：乙方于______年__ 月__ 日前支付给甲方________ ；
          </p>
          <p style="text-indent: 2em">
            第二次支付：乙方于____年__ 月__ 日前支付给甲方____ ；
          </p>
          <p style="text-indent: 2em">
            第三次支付：乙方于____年__ 月__ 日前支付给甲方____ 。）
          </p>
          <p style="text-indent: 2em">
            3.货币计费一次性付款方式。承包费按____元/亩·年计算，共计______元。乙方须于______年__
            月__ 日前支付全部承包费。
          </p>
          <p style="text-indent: 2em">
            4.其他支付方式：________________________________。
          </p>
          <p style="text-indent: 2em">
            5.流转费用变动：________________________________。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            特别提醒：每届村集体经济组织理事会收取的承包费用，不得超过本届村集体经济组织理事会任期的剩余期限。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第四条 甲方的权利和义务
          </p>
          <p style="text-indent: 2em">1.甲方的权利</p>
          <p style="text-indent: 2em">
            ①有权监督乙方按合同约定依法利用和保护该四荒地，制止乙方的损害行为；
          </p>
          <p style="text-indent: 2em">②有权在本合同到期后收回该四荒地；</p>
          <p style="text-indent: 2em">
            ③乙方无正当理由未支付或者延迟支付承包费的，甲方可以要求乙方在合理期限内支付。经催告后，在合理期限内乙方仍未支付的，甲方可以解除合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            ④该发包土地被征收、征用、占用的，有权获得________ 补偿。
          </p>
          <p style="text-indent: 2em">2.甲方的义务</p>
          <p style="text-indent: 2em">①按时交付约定发包的四荒地；</p>
          <p style="text-indent: 2em">
            ②应确认该发包四荒地权属合法、清晰，无任何与该四荒地有关的权属纠纷和经济纠纷；
          </p>
          <p style="text-indent: 2em">
            ③协助乙方处理与其他承包户发生的用路、用水、用电等纠纷；
          </p>
          <p style="text-indent: 2em">
            ④尊重乙方的生产经营自主权，不得干涉乙方依法进行正常的生产经营活动。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第五条 乙方的权利和义务
          </p>
          <p style="text-indent: 2em">1.乙方的权利</p>
          <p style="text-indent: 2em">
            ①依法享有四荒地使用、收益的权利，有权自主组织生产经营和处置产品；
          </p>
          <p style="text-indent: 2em">
            ②有权利用该承包四荒地上已有的开展农业生产所必需的水系、道路、构筑物等设施；
          </p>
          <p style="text-indent: 2em">
            ③合同到期后，有权在同等条件下优先续包；
          </p>
          <p>
            ④承包期间四荒地及周边土地被依法征收、征用、占用的，乙方应服从，但有权获得______________
            补偿。
          </p>
          <p style="text-indent: 2em">2.乙方的义务</p>
          <p style="text-indent: 2em">
            ①按合同约定及时接收该承包四荒地并向甲方足额支付承包费；
          </p>
          <p style="text-indent: 2em">
            ②承包期间，未经登记不得进行抵押及再流转；
          </p>
          <p style="text-indent: 2em">
            ③本合同到期，应提前一个月告知甲方是否续包。不续包的，应于合同到期日交回该流转土地；
          </p>
          <p style="text-indent: 2em">
            ④配合做好四荒地承包合同的审查备案工作；
          </p>
          <p style="text-indent: 2em">
            ⑤负责地上设施的维护和维修，合同到期后完整交付；
          </p>
          <p style="text-indent: 2em">
            ⑥为提高土地生产能力而进行设施改建，应征得甲方同意，需报有关部门批准的，按照相关规定办理；
          </p>
          <p style="text-indent: 2em">
            ⑦妥善管理该承包四荒地上未列入合同的水系、道路、构筑物等设施，如需使用或变动，须征得甲方和发包方同意；
          </p>
          <p style="text-indent: 2em">
            ⑧在法律法规政策和合同约定允许范围内保护和合理利用该承包四荒地，不得破坏农业综合生产能力和农业生态环境，不得撂荒土地、不得擅自改变土地用途、不得给土地造成永久性损害。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第六条 交付时和合同到期后地上附着物及相关设施的处理
          </p>
          <p style="text-indent: 2em">
            1.签订本合同并交付该集体资源性资产时，地上附着物及相关设施有：____________________________________________
            。
          </p>
          <p style="text-indent: 2em">
            2.合同到期时，由国家或地方财政直接补助形成的财产按国家和本市有关规定处理。
          </p>
          <p style="text-indent: 2em">
            3.乙方经营期间利用除财政补助外的资金构建的地上附着物及相关设备设施按下列方式处理：______________________
            。
          </p>
          <p style="text-indent: 2em">
            4.合同到期该集体资源性资产恢复原状等事项的处理：__________________________________________________
            。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第七条 合同变更、解除
          </p>
          <p style="text-indent: 2em">
            1.经协商一致，甲乙双方可对本合同进行变更、解除。
          </p>
          <p style="text-indent: 2em">
            2.当事人一方中途变更或解除合同的，应提前______日书面通知对方。
          </p>
          <p style="text-indent: 2em">
            3.合同有效期内，因不可抗力导致合同无法继续履行的，当事人可以解除合同；双方应按合同解除日期，结清合同履行期间相关费用。
          </p>
          <p style="text-indent: 2em">
            4.当事人一方违约导致合同无法履行的，另一方可以解除合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第八条 违约责任</p>
          <p style="text-indent: 2em">
            1.因变更或解除本合同使一方遭受损失的，除依法可免除责任的情形，应向守约方支付违约金________
            元。如果违约金不足以弥补守约方经济损失，违约方应据实赔偿。
          </p>
          <p style="text-indent: 2em">
            2.甲方逾期交付本合同约定的集体资源性资产，每延迟一天，按承包费用的______%承担违约金。
          </p>
          <p style="text-indent: 2em">
            3.乙方逾期支付承包费，每延迟一天，按应支付费用的______%承担违约金。
          </p>
          <p style="text-indent: 2em">
            4.甲方非法干预乙方生产经营活动，给乙方造成损失的，应予以赔偿。
          </p>
          <p style="text-indent: 2em">
            5.乙方私自在承包区域内取土或未经甲方书面同意私自改变土地用途和结构、破坏水利等基本设施或给土地造成永久性损害的，甲方有权解除合同，乙方应当赔偿对甲方造成的损失。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条 纠纷解决方式</p>
          <p style="text-indent: 2em">
            甲乙双方发生纠纷，可以协商解决，也可以请求乡（镇）人民政府等调解。当事人不愿协商、调解或者协商、调解不成的，可以向农村土地承包仲裁机构申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 特别约定</p>
          <p style="text-indent: 2em">
            1.承包合同生效后，不因承办人或者负责人的变动而变更或者解除，也不因集体经济组织的分立或者合并而变更或者解除。
          </p>
          <p style="text-indent: 2em">
            2.本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条其他约定</p>
          <p style="text-indent: 2em">
            本合同一式四份，双方盖章/签字有效。甲乙双方各执一份，乡（镇）农村综合产权交易服务站备案一份，__
            农村综合产权交易中心留存一份。经协商，决定______（提交/不提交）__
            农村综合产权交易中心鉴证。
          </p>
          <p style="font-weight: 700">甲方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：{{ detail.outname }}
          </p>
          <p>身份证号 （统一社会信用代码）：{{ detail.idnum }}</p>
          <p>联系方式：{{ detail.phone }}</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ detail.address }}
          </p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乙方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：____________________________________
          </p>
          <p>身份证号 （统一社会信用代码）：________________________</p>
          <p>联系方式：_______________</p>
          <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：_______________</p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乡镇农村综合产权交易服务站备案意见</p>
          <p>备案人：______________________</p>
          <p>备案日期：________年____月____日</p>
          <br />
          <p style="font-weight: 700">
            鉴 证 方（签字/签章）：{{ cityDetail.cityName }}农村综合产权交易中心
          </p>
          <P
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：____________________________________________</P
          >
          <P>联系方式：____________________________________________</P>
          <P>鉴证日期：________年____月____日</P>
          <P style="text-indent: 2em">合同附件：</P>
          <P style="font-weight: 700; text-align: center"
            >资源性资产基本情况表</P
          >
          <br />
          <table border="1">
            <tr>
              <th style="width: 100px" rowspan="3">序号</th>
              <th rowspan="3">资源名称</th>
              <th rowspan="3">面积（亩）</th>
              <td colspan="4" rowspan="1" style="text-align: center">
                四至界限
              </td>
            </tr>
            <tr>
              <th rowspan="2">东</th>
              <th rowspan="2">南</th>
              <th rowspan="2">西</th>
              <th rowspan="2">北</th>
            </tr>
            <tr></tr>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>3</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="7">......</td>
            </tr>
            <tr>
              <td>合计</td>
              <td colspan="6">（大写）____________亩（小写）__________亩</td>
            </tr>
          </table>
        </div>
        <!-- c3.docx 养殖水面 -->
        <div
          class="hetongBox"
          v-else-if="getOutPorjectType(detail.number) == '养殖水面'"
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村集体资源性资产（坑塘水面）承包合同
          </p>
          <p style="font-size: 22px; text-align: center">
            （本合同适用于村集体经济组织发包坑塘水面时使用）
          </p>
          <br />
          <p>
            发包方（以下简称甲方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            承包方（以下简称乙方）：<span
              >________________________________________</span
            >
          </p>
          <br />
          <p style="text-indent: 2em">
            为维护承包双方当事人的合法权益，根据《中华人民共和国合同法》、《中华人民共和国物权法》、《中华人民共和国农村土地承包法》、《中华人民共和国农村土地承包经营纠纷调解仲裁法》等法律、法规和国家有关政策规定以及本集体经济组织依法通过的农村集体资源性资产发包方案，甲乙双方本着平等、自愿、公平、诚信的原则，经协商一致，订立本合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第一条 集体资源性资产基本情况与用途
          </p>
          <p style="text-indent: 2em">
            甲方将位于________占地总面积为
            <span style="text-decoration: underline">{{ detail.area }}</span>
            亩的坑塘水面（详见资源性资产基本情况表）通过______县农村综合产权交易中心以____________（招标/拍卖/公开协商）方式承包给乙方，从事____________生产经营。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第二条 承包期限和交付时间
          </p>

          <p style="text-indent: 2em">
            承包期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，自
            <span style="text-decoration: underline">
              {{ detail.outstarttime }}
            </span>
            起至
            <span style="text-decoration: underline">
              {{ detail.outstoptime }}</span
            >
            止。
            <span style="font-weight: 700"
              >（不得超过每届村集体经济组织理事会任期的剩余期限）。</span
            >
            甲方应于________ 年______月______日之前将该坑塘水面交付乙方。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第三条 承包费用与支付方式
          </p>
          <p style="text-indent: 2em">承包费用按下列第__ 种方式计算：</p>
          <p style="text-indent: 2em">
            1.货币计费分期支付方式。承包费按照__
            元/亩标准计算，合计______元/年。乙方须于__ 年__ 月__
            日前支付当年承包费。
          </p>
          <p style="text-indent: 2em">
            （或：第一次支付：乙方于______年__ 月__ 日前支付给甲方________ ；
          </p>
          <p style="text-indent: 2em">
            第二次支付：乙方于__ 年__ 月__ 日前支付给甲方______；
          </p>
          <p style="text-indent: 2em">
            第三次支付：乙方于__ 年__ 月__ 日前支付给甲方______。）
          </p>
          <p style="text-indent: 2em">
            2.货币计费一次性付款方式。承包费按_____元/亩·年计算，共计______元。乙方须于______年__
            月__ 日前支付全部承包费。
          </p>
          <p style="text-indent: 2em">
            3.其他支付方式：________________________________。
          </p>
          <p style="text-indent: 2em">
            4.承包费变动：__________________________________。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第四条 甲方的权利和义务
          </p>
          <p style="text-indent: 2em">1.甲方的权利</p>
          <p style="text-indent: 2em">
            ①有权监督乙方按合同约定依法利用和保护该坑塘水面，制止乙方的损害行为；
          </p>
          <p style="text-indent: 2em">②有权在本合同到期后收回该坑塘水面；</p>
          <p style="text-indent: 2em">
            ③乙方无正当理由未支付或者延迟支付承包费的，甲方可以要求乙方在合理期限内支付。经催告后，在合理期限内乙方仍未支付的，甲方可以解除合同。
          </p>
          <p style="text-indent: 2em">
            ④该坑塘水面被征收、征用、占用的，有权获得______补偿。
          </p>
          <p style="text-indent: 2em">2.甲方的义务</p>
          <p style="text-indent: 2em">①按时交付约定发包的坑塘水面；</p>
          <p style="text-indent: 2em">
            ②应确认该发包坑塘水面权属合法、清晰，无任何与该坑塘水面有关的权属纠纷和经济纠纷；
          </p>
          <p style="text-indent: 2em">
            ③协助乙方处理与其他承包户发生的用路、用水、用电等纠纷；
          </p>
          <p style="text-indent: 2em">
            ④尊重乙方的生产经营自主权，不得干涉乙方依法进行正常的生产经营活动。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第五条 乙方的权利和义务
          </p>
          <p style="text-indent: 2em">1.乙方的权利</p>
          <p style="text-indent: 2em">
            ①依法享有坑塘水面使用、收益的权利，有权自主组织生产经营和处置产品；
          </p>
          <p style="text-indent: 2em">
            ②有权利用该坑塘水面上已有的开展农业生产所必需的水系、道路、构筑物等设施；
          </p>
          <p style="text-indent: 2em">
            ③合同到期后，有权在同等条件下优先续包；
          </p>
          <p style="text-indent: 2em">
            ④承包期间坑塘水面及周边土地被依法征收、征用、占用的，乙方应服从，但有权获得______________
            补偿。
          </p>
          <p style="text-indent: 2em">2.乙方的义务</p>
          <p style="text-indent: 2em">
            ①按合同约定及时接收该承包坑塘水面并向甲方足额支付承包费；
          </p>
          <p style="text-indent: 2em">
            ②承包期间，未经登记不得进行抵押及再流转；
          </p>
          <p style="text-indent: 2em">
            ③本合同到期，应提前一个月告知甲方是否续包。不续包的，应于合同到期日交回该流转坑塘水面；
          </p>
          <p style="text-indent: 2em">
            ④配合做好坑塘水面承包合同的审查备案工作；
          </p>
          <p style="text-indent: 2em">
            ⑤负责生产设施的维护和维修，合同到期后完整交付；
          </p>
          <p style="text-indent: 2em">
            ⑥为提高生产能力而进行设施改建，应征得甲方同意，需报有关部门批准的，按照相关规定办理；
          </p>
          <p style="text-indent: 2em">
            ⑦妥善管理该承包坑塘水面上未列入合同的水系、道路、构筑物等设施，如需使用或变动，须征得甲方同意；
          </p>
          <p style="text-indent: 2em">
            ⑧在法律法规政策和合同约定允许范围内保护和合理利用该承包坑塘水面，不得破坏农业综合生产能力和农业生态环境，不得擅自改变生产用途、不得给坑塘水面造成永久性损害。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第六条 交付时和合同到期后地上附着物及相关设施的处理
          </p>
          <p style="text-indent: 2em">
            1.签订本合同并交付该集体资源性资产时，地上附着物及相关设施有：____________________________________________
            。
          </p>
          <p style="text-indent: 2em">
            2.合同到期时，由国家或地方财政直接补助形成的财产按国家和本县有关规定处理。
          </p>
          <p style="text-indent: 2em">
            3.乙方经营期间利用除财政补助外的资金构建的地上附着物及相关设备设施按下列方式处理：______________________。
          </p>
          <p style="text-indent: 2em">
            4.合同到期该集体资源性资产恢复原状等事项的处理：__ 。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第七条 合同变更、解除
          </p>
          <p style="text-indent: 2em">
            1.经协商一致，甲乙双方可对本合同进行变更、解除。
          </p>
          <p style="text-indent: 2em">
            2.当事人一方中途变更或解除合同的，应提前______日书面通知对方。
          </p>
          <p style="text-indent: 2em">
            3.合同有效期内，因不可抗力导致合同无法继续履行的，当事人可以解除合同；双方应按合同解除日期，结清合同履行期间相关费用。
          </p>
          <p style="text-indent: 2em">
            4.当事人一方违约导致合同无法履行的，另一方可以解除合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第八条 违约责任</p>
          <p style="text-indent: 2em">
            1.因变更或解除本合同使一方遭受损失的，除依法可免除责任的情形，应向守约方支付违约金________
            元。如果违约金不足以弥补守约方经济损失，违约方应据实赔偿。
          </p>
          <p style="text-indent: 2em">
            2.甲方逾期交付本合同约定的集体资源性资产，每延迟一天，按承包费用的______%承担违约金。
          </p>
          <p style="text-indent: 2em">
            3.乙方逾期支付承包费，每延迟一天，按应支付费用的__ %承担违约金。
          </p>
          <p style="text-indent: 2em">
            4.甲方非法干预乙方生产经营活动，给乙方造成损失的，应予以赔偿。
          </p>
          <p style="text-indent: 2em">
            5.乙方私自在承包区域内取土或未经甲方书面同意私自改变生产用途和结构、破坏水利等基本设施或给资源性资产造成永久性损害的，甲方有权解除合同，乙方应当赔偿对甲方造成的损失。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条 纠纷解决方式</p>
          <p style="text-indent: 2em">
            甲乙双方发生纠纷，可以协商解决，也可以请求乡（镇）人民政府等调解。当事人不愿协商、调解或者协商、调解不成的，可以向农村土地承包仲裁机构申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 特别约定</p>
          <p style="text-indent: 2em">
            1.在同等条件下，本集体经济组织成员有权优先承包。如乙方为本集体经济组织以外的单位或者个人，应当事先经本集体经济组织成员的村民会议三分之二以上成员或者三分之二以上村民代表的同意，并报乡(镇)人民政府批准，且甲方应当对乙方的资信情况和经营能力进行审查后，再签订承包合同。
          </p>
          <p style="text-indent: 2em">
            2.承包合同生效后，不因承办人或者负责人的变动而变更或者解除，也不因集体经济组织的分立或者合并而变更或者解除。
          </p>
          <p style="text-indent: 2em">
            本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条 其他约定</p>
          <p style="text-indent: 2em">
            ______________________________________________。
          </p>
          <p style="text-indent: 2em">
            本合同一式四份，双方盖章/签字有效。甲乙双方各执一份，乡（镇）农村综合产权交易服务站备案一份，______县农村综合产权交易中心留存一份。经协商，决定______（提交/不提交）______县农村综合产权交易中心鉴证。
          </p>
          <p style="font-weight: 700">甲方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：{{ detail.outname }}
          </p>
          <p>身份证号 （统一社会信用代码）：{{ detail.idnum }}</p>
          <p>联系方式：{{ detail.phone }}</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ detail.address }}
          </p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乙方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：____________________________________
          </p>
          <p>身份证号 （统一社会信用代码）：________________________</p>
          <p>联系方式：_______________</p>
          <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：_______________</p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乡镇农村综合产权交易服务站备案意见</p>
          <p>备案人：______________________</p>
          <p>备案日期：________年____月____日</p>
          <br />
          <p style="font-weight: 700">
            鉴 证 方（签字/签章）：{{ cityDetail.cityName }}农村综合产权交易中心
          </p>
          <P
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：____________________________________________</P
          >
          <P>联系方式：____________________________________________</P>
          <P>鉴证日期：________年____月____日</P>
          <P style="text-indent: 2em">合同附件：</P>
          <P style="font-weight: 700; text-align: center"
            >资源性资产基本情况表</P
          >
          <br />
          <table border="1">
            <tr>
              <th style="width: 100px" rowspan="3">序号</th>
              <th rowspan="3">资源名称</th>
              <th rowspan="3">面积（亩）</th>
              <td colspan="4" rowspan="1" style="text-align: center">
                四至界限
              </td>
            </tr>
            <tr>
              <th rowspan="2">东</th>
              <th rowspan="2">南</th>
              <th rowspan="2">西</th>
              <th rowspan="2">北</th>
            </tr>
            <tr></tr>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>3</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="7" style="text-align: center">......</td>
            </tr>
            <tr>
              <td>合计</td>
              <td colspan="6">（大写）____________亩（小写）__________亩</td>
            </tr>
          </table>
        </div>
        <!-- c4.docx 林地林木 -->
        <div
          class="hetongBox"
          v-else-if="
            getOutPorjectType(detail.number) == '林地林木' ||
            getOutPorjectType(detail.number) == '林权'
          "
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}集体林地承包合同
          </p>
          <p>
            发包方：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            身份证号码：<span style="text-decoration: underline">{{
              detail.idnum
            }}</span>
          </p>
          <p>
            联系方式：<span style="text-decoration: underline">{{
              detail.phone
            }}</span>
          </p>
          <p>
            住&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所：<span
              style="text-decoration: underline"
              >{{ detail.address }}</span
            >
          </p>
          <p>承包方：<span>________________________________________</span></p>
          <p>
            身份证号码：<span>________________________________________</span>
          </p>
          <p>联系方式：<span>________________________________________</span></p>
          <p>
            住&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所：<span
              >________________________________________</span
            >
          </p>
          <br />
          <p style="text-indent: 2em">
            为维护林地承包双方当事人的合法权益，促进林业发展，根据《中华人民共和国农村土地承包法》、《中华人民共和国森林法》、《中华人民共和国合同法》、《中华人民共和国物权法》等有关法律法规，按照本集体经济组织成员会议三分之二以上成员(或者三分之二以上村民代表)同意的林地承包方案，在公开、平等、自愿的原则下，经双方协商同意，订立本合同。
          </p>
          <br />
          <p style="font-weight: 700; text-indent: 2em">第一条 承包林地情况</p>
          <p style="text-indent: 2em">
            发包方将坐落在
            <span style="text-decoration: underline">{{ detail.address }} </span
            >的林地，宗地序号：______宗地编号：____________________，树种：________
            ，面积共
            <span style="text-decoration: underline">{{ detail.area }}</span>
            亩的林地（具体见下表及附图）承包经营权和林木所有权以____________（家庭承包形式为协商一致；“四荒地”非家庭承包形式为招标、拍卖、公开协商等其他形式）的方式发包给承包方，承包期限自
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            起至
            <span style="text-decoration: underline">{{
              detail.outstoptime
            }}</span>
            止共
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年。
          </p>
          <p>上述林地、林木交付现状：____________________ 。</p>
          <table border="1">
            <tr>
              <th style="width: 100px" rowspan="3">序号</th>
              <th rowspan="3">地块名称</th>
              <th rowspan="3">面积(亩)</th>
              <td colspan="4" rowspan="1" style="text-align: center">
                四至界限
              </td>
            </tr>
            <tr>
              <th rowspan="2">东</th>
              <th rowspan="2">南</th>
              <th rowspan="2">西</th>
              <th rowspan="2">北</th>
            </tr>
            <tr></tr>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>3</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>4</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>5</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>6</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <br />
          <p style="font-weight: 700; text-indent: 2em">
            第二条 承包林地的用途
          </p>
          <p>
            本承包林地必须用于林业生产，未经依法批准不得用于非林业建设或者其他建设。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第三条 承包价款及支付方式、期限
          </p>
          <p style="text-indent: 2em">（一）承包价款</p>
          <p style="text-indent: 2em">
            本合同约定林地承包价款总计为__________
            元人民币（大写：____________人民币）
          </p>
          <p style="text-indent: 2em">
            1.林地承包价格为______ 元/亩/年，承包______年合计________ 元人民币。
          </p>
          <p style="text-indent: 2em">
            2.林地上附属建筑及设施承包价款为______元人民币。
          </p>
          <p style="text-indent: 2em">3.林地上林木承包款为______元人民币。</p>
          <p style="text-indent: 2em">（二）价款支付方式及支付时间</p>
          <p style="text-indent: 2em">承包方采取下列第__ 种方式支付：</p>
          <p style="text-indent: 2em">1.现金方式一次性支付：</p>
          <p style="text-indent: 2em">
            ______________________________________ 。
          </p>
          <p style="text-indent: 2em">2.分期付款支付:</p>
          <p style="text-indent: 2em">
            ______________________________________ 。
          </p>
          <p style="text-indent: 2em">3.其他方式支付：</p>
          <p style="text-indent: 2em">
            ______________________________________ 。
          </p>
          <br />
          <p style="font-weight: 700; text-indent: 2em">
            第四条 双方的权利和义务
          </p>
          <p style="text-indent: 2em">（一）发包方的权利和义务</p>
          <p style="text-indent: 2em">1.权利</p>
          <p style="text-indent: 2em">
            （1）发包方有权监督承包方依照本合同约定的用途合理利用和保护林地。
          </p>
          <p style="text-indent: 2em">
            （2）发包方有权制止承包方损害承包林地和其他森林资源的行为。
          </p>
          <p style="text-indent: 2em">
            （3）承包方对承包林地造成永久性损害的，发包方有权向承包方要求损害赔偿。
          </p>
          <p style="text-indent: 2em">
            （4）发包方有基于承包林地所有权获得收益的权利。
          </p>
          <p style="text-indent: 2em">
            （5）发包方有权要求承包方按规划完成造林任务。
          </p>
          <p style="text-indent: 2em">2.义务</p>
          <p style="text-indent: 2em">
            （1）确认前述承包的林地、林木产权清晰，没有权属纠纷和经济纠纷；没有作为抵押或担保物。
          </p>
          <p style="text-indent: 2em">
            （2）维护承包方的林地承包经营权，不得擅自变更、解除承包合同。
          </p>
          <p style="text-indent: 2em">
            （3）尊重承包方的生产经营自主权，不得干涉承包方依法经合同约定进行正常的生产经营活动。
          </p>
          <p style="text-indent: 2em">（4）协助承包方申领林权证。</p>
          <p style="text-indent: 2em">
            （5）协助承包方做好护林防火、林业有害生物防治等工作。
          </p>
          <p style="text-indent: 2em">
            （6）依照本合同约定为承包方提供生产、技术、信息等服务。
          </p>
          <p style="text-indent: 2em">（二）承包方的权利和义务</p>
          <p style="text-indent: 2em">1.权利</p>
          <p style="text-indent: 2em">
            （1）依法享有承包林地使用、收益权；有权自主组织生产经营和依法处置林木及产品；有权依法自主决定承包林地是否流转和流转的方式。
          </p>
          <p style="text-indent: 2em">（2）享受国家优惠政策和扶持。</p>
          <p style="text-indent: 2em">
            （3）以家庭承包方式承包林地的，在承包期内，承包方家庭内部成员分户需要对承包林地进行分割经营的，可经家庭成员协商一致后，以原承包合同为依据，各分立的家庭分别与发包方签订承包合同，并依法申办林权证变更登记手续。
          </p>
          <p style="text-indent: 2em">
            （4）林地承包的承包人死亡，其继承人可以在承包期内依法继续承包。
          </p>
          <p style="text-indent: 2em">
            （5）承包期内承包林地被依法征用、占用的，有权依法获得相应的补偿。
          </p>
          <p style="text-indent: 2em">2.义务</p>
          <p style="text-indent: 2em">
            （1）维持承包林地的林业用途，不得用于非林建设或者使之闲置荒地。属生态公益林的，不得改变公益林性质。
          </p>
          <p style="text-indent: 2em">
            （2）落实造林和管护措施。荒地应自承包合同生效之日起______年内参照国家有关造林标准造林。林木采伐后应在当年或次年更新。
          </p>
          <p style="text-indent: 2em">
            （3）依法保护和合理利用林地，不得自行或准许他人在承包林地内实施毁林开垦、挖沙、取土等给林地造成永久性损害的行为。在承包林地内发生毁林和乱占滥用林地行为时，应积极采取措施予以制止，并及时向有关部门报告。
          </p>
          <p style="text-indent: 2em">
            （4）保护好野生动物、植物资源，依法做好森林防火和林业有害生物防治工作。
          </p>
          <p style="text-indent: 2em">
            （5）在承包期内转让林地承包经营权的，应经发包方同意，否则转让无效；转包（仅家庭承包方式适用）、出租、互换（仅家庭承包方式适用）或者以其他方式流转林地承包经营权的，应当报发包方备案。
          </p>
          <p style="text-indent: 2em">
            （6）及时、足额支付承包费。如遇国家征用、占用林地，配合林业等有关部门办理相关手续。
          </p>
          <p style="text-indent: 2em">
            （7）配合发包方执行县、乡（镇）林业总体规划、重点工程实施方案，组织本集体经济组织内部的林业基础设施建设。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第五条 特别约定</p>
          <p style="text-indent: 2em">
            （一）发包方通过招标、拍卖、公开协商等方式发包“四荒地”林地经营权的，应提供：
          </p>
          <p style="text-indent: 2em">1.发包方《林权证》原件复印件；</p>
          <p style="text-indent: 2em">
            2.依法经本集体经济组织成员的成员会议三分之二以上成员或者村民代表会议三分之二以上村民代表同意承包的票决记录复印件；
          </p>
          <p style="text-indent: 2em">3.乡镇政府批准意见书。</p>
          <p style="text-indent: 2em">（二）其他：</p>
          <p style="text-indent: 2em">
            ______________________________________ 。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第六条 合同的变更、解除和终止
          </p>
          <p style="text-indent: 2em">
            （一）本合同法律效力不受双方（发包方、承包方）负责人变动影响，也不因集体经济组织的分立或合并而变更或解除，任何一方不得擅自终止合同。
          </p>
          <p style="text-indent: 2em">
            （二）合同有效期间，如因政府依法征占用该承包林地，或者因不可抗力因素致使合同全部不能履行时，本合同自动终止。
          </p>
          <p style="text-indent: 2em">
            （三）承包合同期满后，承包方在__
            日内将原承包的林地交还给发包方。未采伐林木的处理方式约定为______。
          </p>
          <p style="text-indent: 2em">
            （四）合同终止或解除后，原由承包方修建的道路、灌溉渠等设施，处置方式为________
            。修建的房屋及其他可拆卸设施，处置方式为________________。
          </p>
          <p style="text-indent: 2em">
            （五）合同期满后，如承包方继续承包经营该林地，在同等条件下，承包方拥有优先承包经营权，但需与发包方重新协商签订合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第七条 违约责任</p>
          <p style="text-indent: 2em">
            （一）本合同签订后，如因发包方发包地手续不合法或因发包地权属不清产生纠纷，致使合同全部或部分不能履行的，视为发包方违约，由发包方负责协调处理，由此给承包方造成经济损失的，由发包方负责全额赔偿。
          </p>
          <p style="text-indent: 2em">
            （二）承包期内，发包方擅自收回承包林地，或者干预承包方正常的生产经营活动，使承包方遭受损失的，应承担赔偿责任。
          </p>
          <p style="text-indent: 2em">
            （三）承包期内，承包方未按规定用途使用承包地、改变林地用途，未按合同约定落实造林营林等经营及管护责任，或者造成林地永久性损害的，经劝阻无效发包方可依法解除合同，并由承包方承担林地恢复费用。
          </p>
          <p style="text-indent: 2em">
            （四）承包方不按约定缴纳林地承包费用，按日承担应缴资金______‰的滞纳金；逾期超过30日不缴纳的，发包方可解除合同收回承包林地。
          </p>
          <p style="text-indent: 2em">
            （五）承包方在承包的林地上非法建筑、取土等改变林地用途的，发包方有权终止合同，并视情节交由相关部门处理。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第八条 合同争议的解决方式
          </p>
          <p style="text-indent: 2em">
            本合同在履行过程中发生的合同争议，由双方协商解决；协商不成的，由村民委员会、乡镇政府等进行调解;协商、调解不成的，可采取以下第__
            种方式解决：
          </p>
          <p style="text-indent: 2em">
            （一）向______________ 仲裁委员会申请仲裁；
          </p>
          <p style="text-indent: 2em">
            （二）向____ 县____________人民法院申请诉讼。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条 其他约定</p>
          <p style="text-indent: 2em">
            __________________________________________。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 其他事项</p>
          <p style="text-indent: 2em">
            （一）本合同履行期间，如有未尽事宜，应由双方共同协商，作出补充规定，补充规定与本合同具有同等效力。
          </p>
          <p style="text-indent: 2em">
            （二）本合同一式____份，由发包方、承包方、乡镇林业主管部门、__县农村综合产权交易中心________
            各执一份。
          </p>
          <p style="text-indent: 2em">（三）本合同自签订之日起生效。</p>
          <br />
          <p>发包方（盖章）：____________负责人（签字）:__________________</p>
          <p style="text-align: right">签约日期：____ 年______月____日</p>
          <p>承包方（盖章）：____________负责人（签字）：______________</p>
          <p style="text-align: right">签约日期：____ 年______月____日</p>
          <br />
          <p>乡（镇）政府主管部门（盖章）</p>
          <p>附件：承包林地四至范围附图</p>
        </div>
        <!-- c5.docx 农村宅基地 闲置农房 -->
        <div
          class="hetongBox"
          v-else-if="
            getOutPorjectType(detail.number) == '农村宅基地' ||
            getOutPorjectType(detail.number) == '闲置农房' ||
            getOutPorjectType(detail.number) == '集体经营性资产' ||
            getOutPorjectType(detail.number) == '农村集体经营性资产'
          "
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村房屋租赁合同
          </p>

          <br />
          <br />
          <br />
          <p>
            出租人（以下简称甲方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            承租人（以下简称乙方）：________________________________________
          </p>
          <p style="text-indent: 2em">
            根据《中华人民共和国合同法》等有关法律、法规，甲、乙双方遵循自愿、平等、公平、诚实信用的原则，经协商一致，达成如下条款：
          </p>
          <p style="text-indent: 2em; font-weight: 700">第一条 标的物情况</p>
          <p style="text-indent: 2em">
            1.甲方将座落于<span style="text-decoration: underline">{{
              detail.address
            }}</span
            >{{ getDictValue(detail.rollout, "out_type") }}给乙方。该出租标的{{
              detail.area + getDictValue(detail.areaUnit, "area_unit")
            }}，总成交额：¥___________________元，结构________________房屋四至东：
            <span style="text-decoration: underline">{{ detail.east }}</span>
            西：
            <span style="text-decoration: underline">{{ detail.west }}</span>
            南：
            <span style="text-decoration: underline">{{ detail.south }}</span>
            北：
            <span style="text-decoration: underline">{{ detail.north }}</span>
            ， 该房屋未设定抵押。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第二条 租赁用途</p>
          <p style="text-indent: 2em">
            1.乙方所承租标的用于____________（居住/商业/服务业/办公/其它约定）。
          </p>
          <p style="text-indent: 2em">
            2.乙方应按照约定的用途使用房屋，不得利用承租标的进行违法违规活动。乙方改变标的用途的，应征得甲方书面同意。未经甲方书面同意，乙方擅自改变标的用途，甲方可以解除合同，并要求乙方赔偿损失。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第三条 租赁期限和交付日期
          </p>
          <p style="text-indent: 2em">
            1.标的租赁期限
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            起至
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            止。
          </p>
          <p style="text-indent: 2em">
            2.甲方于___________年_________月_________日前，将出租标的交付乙方。甲方延期交付标的。
          </p>
          <p style="text-indent: 2em">
            3.租赁期届满时，甲方有权收回标的，乙方应按期返还。乙方需继续承租该标的时，应提前______________个月与甲方协商。甲方要求返还标的，乙方逾期返还的，自租赁期届满之次日起至实际返还标的之日止，乙方除支付租金外，还应按每日___________元向甲方支付违约金。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第四条 租金、支付方式和期限
          </p>
          <p style="text-indent: 2em">
            1. 甲、乙双方按下列第________________种方式计算租金。
          </p>
          <p style="text-indent: 2em">
            ①按建筑面积计算租金，每平方米（月租金、日租金）为________________元（人民币）；
          </p>
          <p style="text-indent: 2em">
            ②按使用面积计算租金，每平方米（月租金、日租金）为________________元（人民币）；
          </p>
          <p style="text-indent: 2em">
            ③按座计算租金，每座租金为 ¥____________元（人民币）。
          </p>
          <p style="text-indent: 2em">
            2.乙方按下列第_________________种方式支付租金。
          </p>
          <p style="text-indent: 2em">
            ①按月支付租金，付款时间____________________。
          </p>
          <p style="text-indent: 2em">
            ②按季支付租金，付款时间_________________。
          </p>
          <p style="text-indent: 2em">
            ③按年支付租金，付款时间_________________。
          </p>
          <p style="text-indent: 2em">3. 租金变动：_________________。</p>
          <p style="text-indent: 2em">
            4．乙方延期支付租金，甲方有权按下述第_________________种约定追究乙方违约责任：
          </p>
          <p style="text-indent: 2em">
            ①合同继续履行。乙方除应支付拖欠租金外，还应自应交租金之次日起至实际交付拖欠租金之日止，按每日__________元向甲方支付违约金。
          </p>
          <p style="text-indent: 2em">
            ②解除合同。乙方拖欠租金累计达___________个月及其以上的，甲方可以解除合同。乙方除应支付累计拖欠租金外，还应自解除合同之次日起至实际交付拖欠租金之日止，按每日__________元向甲方支付违约金。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第五条 押金和其他费用
          </p>
          <p style="text-indent: 2em">
            1.甲方交付该标的时，乙方向甲方支付押金，押金为__________元。甲方收取押金后，应向乙方开具收条。租赁关系终止时，甲方收取的押金以及产生的利息除用以抵充应由乙方承担的__________费用外，剩余部分归还乙方。
          </p>
          <p style="text-indent: 2em">
            2.租赁期间，使用该标的所发生的物业管理费用由 甲方
            承担；其他有关费用，均由 乙方 承担。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            第六条 标的使用和维修
          </p>
          <p style="text-indent: 2em">
            1.在租赁期内，甲方应保证出租标的的使用安全。乙方应合理使用其所承租的标的及其附属设备。
          </p>
          <p style="text-indent: 2em">
            2.租赁期间，乙方拆改标的的，应预先征得甲方书面同意，并按规定报经住建管理部门批准。未经甲方书面同意，乙方拆改标的的，甲方可以解除合同，并要求乙方赔偿损失。
          </p>
          <p style="text-indent: 2em">
            乙方装修标的、增加设备的，应预先征得甲方书面同意，并商定增加的装修、设备的归属及维修责任（见附件）。未经甲方书面同意，乙方装修标的、增加设备，或因使用不当使标的和设备损坏的，甲方可以要求乙方给予修复，并赔偿损失。
          </p>
          <p style="text-indent: 2em">
            3.标的及原有附属设备因乙方正常使用，发生损坏的，双方按下列第___________种方式承担维修责任。
          </p>
          <p style="text-indent: 2em">
            ①甲方负责出租标的及原有附属设备的维修，承担维修费用；乙方发现标的及原有附属设备有损坏或故障时，应及时通知甲方修复；甲方应在接到乙方通知后_________日内进行维修，乙方应予以协助。逾期不维修的，乙方可代为维修，甲方承担维修费用及逾期维修造成的损失。
          </p>
          <p style="text-indent: 2em">
            ②乙方负责承租标的及原有附属设备的维修，并承担维修费用，甲方应予以协助。
          </p>
          <p style="text-indent: 2em">_______________________</p>
          <p style="text-indent: 2em; font-weight: 700">
            第七条 标的转租及出售
          </p>
          <p style="text-indent: 2em">
            1.经甲方同意，乙方可以将承租的标的转租给第三人使用。转租期限不得超过本合同约定的终止日期。乙方转租的，甲乙双方的租赁合同继续有效。
          </p>
          <p style="text-indent: 2em">
            未经甲方同意，乙方擅自转租的，甲方可以解除合同，并要求乙方赔偿损失。
          </p>
          <p style="text-indent: 2em">
            2.甲方在租赁期限内出售乙方承租标的时，应提前三个月通知乙方，同等条件下，乙方可优先购买，但乙方应依法取得购买资格方可。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第八条 提前解除合同</p>
          <p style="text-indent: 2em">
            1.租赁期间，非本合同约定的情况，甲方解除本合同，提前收回标的的，甲方向乙方支付违约金_____________元。若约定的违约金不足抵付乙方损失的，甲方还应负责赔偿超过违约金部分的损失。
          </p>
          <p style="text-indent: 2em">
            2.租赁期间，非本合同约定的情况，乙方解除本合同的，乙方向甲方支付违约金_____________元。若约定的违约金不足抵付甲方损失的，乙方还应负责赔偿超过违约金部分的损失。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第九条 纠纷解决方式</p>
          <p style="text-indent: 2em">
            甲乙双方发生纠纷，可以协商解决，也可以请求乡（镇）人民政府等调解。当事人不愿协商、调解或者协商、调解不成的，可以向仲裁委员会申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第十条 其他条款</p>
          <p style="text-indent: 2em">
            1.租赁期间，甲方抵押该标的，须书面通知乙方。
          </p>
          <p style="text-indent: 2em">
            2.本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="text-indent: 2em; font-weight: 700">第十一条 其他约定</p>
          <p style="text-indent: 2em">
            _______________________________________________
          </p>
          <p style="text-indent: 2em">
            本合同一式三份，双方盖章/签字有效。甲乙双方各执一份，获嘉县农村产权交易中心留存一份。经协商，决定提交县农村产权交易中心鉴证。
          </p>
          <br />
          <br />
          <br />
          <div
            style="display: flex; flex-flow: row nowrap; align-items: center"
          >
            <div style="flex: 1">
              <p>甲方:</p>
              <p>法定代表人或主要负责人姓名：</p>
              <p>_________________年__________月__________日</p>
            </div>
            <div style="flex: 1">
              <p>乙方:</p>
              <p>自然人姓名：</p>
              <p>_________________年__________月__________日</p>
            </div>
          </div>
        </div>
        <!-- c6.docx 集体建设用地 -->
        <div
          class="hetongBox"
          v-else-if="getOutPorjectType(detail.number) == '集体建设用地'"
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村集体建设用地使用合同
          </p>
          <p style="font-size: 22px; text-align: center">
            （本合同适用于村集体经济组织的建设用地）
          </p>
          <br />
          <p>
            发包方（以下简称甲方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            承包方（以下简称乙方）：<span
              >________________________________________</span
            >
          </p>
          <br />
          <p style="text-indent: 2em">
            为维护承包双方当事人的合法权益，根据《中华人民共和国合同法》、《中华人民共和国物权法》、《中华人民共和国农村土地承包法》、《中华人民共和国农村土地承包经营纠纷调解仲裁法》等法律、法规和国家有关政策规定以及本集体经济组织依法通过的农村集体资源性资产发包方案，甲乙双方本着平等、自愿、公平、诚信的原则，经双方协商一致，订立本合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第一条 集体资源性资产基本情况与用途
          </p>
          <p style="text-indent: 2em">
            甲方将位于
            <span style="text-decoration: underline">{{ detail.area }}</span>
            占地总面积为
            <span style="text-decoration: underline">{{ detail.area }}</span>
            平方米的建设用地通过__
            农村综合产权交易中心以__拍卖__（招标/拍卖/公开协商）方式承包给乙方，从事______
            。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第二条 承包期限和交付时间
          </p>
          <p style="text-indent: 2em">
            承包期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，自
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            起至
            <span style="text-decoration: underline">{{
              detail.outstoptime
            }}</span>
            止。甲方应于______年__ 月__ 日之前将该建设用地交付乙方。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第三条 承包费用与支付方式
          </p>
          <p style="text-indent: 2em">承包费用按下列第__ 种方式计算：</p>
          <p style="text-indent: 2em">
            1.实物计费货币结算方式。乙方须于________ （当/前一）年__ 月__
            日前按每平方米____________元为标准向甲方支付当年承包费。
          </p>
          <p style="text-indent: 2em">
            2.货币计费分期支付方式。承包费按照______元/平方米标准计算，合计______元/年。乙方须于______年__
            月__ 日前支付当年承包费。
          </p>
          <p style="text-indent: 2em">
            （或：第一次支付：乙方于______年__ 月__ 日前支付给甲方________ ；
          </p>
          <p style="text-indent: 2em">
            第二次支付：乙方于____年__ 月__ 日前支付给甲方____ ；
          </p>
          <p style="text-indent: 2em">
            第三次支付：乙方于____年__ 月__ 日前支付给甲方____ 。）
          </p>
          <p style="text-indent: 2em">
            3.货币计费一次性付款方式。承包费按____元/平方米·年计算，共计______元。乙方须于______年__
            月__ 日前支付全部承包费。
          </p>
          <p style="text-indent: 2em">
            4.其他支付方式：________________________________ 。
          </p>
          <p style="text-indent: 2em">
            5.承包费用变动：________________________________ 。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            特别提醒：每届村集体经济组织理事会收取的承包费用，不得超过本届村集体经济组织理事会任期的剩余期限。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第四条 甲方的权利和义务
          </p>
          <p style="text-indent: 2em">1.甲方的权利</p>
          <p style="text-indent: 2em">
            ①有权监督乙方按合同约定依法利用和保护该集体建设用地，制止乙方的损害行为；
          </p>
          <p style="text-indent: 2em">
            ②有权在本合同到期后收回该集体建设用地；
          </p>
          <p style="text-indent: 2em">
            ③乙方无正当理由未支付或者延迟支付承包费的，甲方可以要求乙方在合理期限内支付。经催告后，在合理期限内乙方仍未支付的，甲方可以解除合同。
          </p>
          <p style="text-indent: 2em">
            ④该发包土地被征收、征用、占用的，有权获得________ 补偿。
          </p>
          <p style="text-indent: 2em">2.甲方的义务</p>
          <p style="text-indent: 2em">①按时交付约定发包的集体建设用地；</p>
          <p style="text-indent: 2em">
            ②应确认该发包集体建设用地权属合法、清晰，无任何与该集体建设用地有关的权属纠纷和经济纠纷；
          </p>
          <p style="text-indent: 2em">
            ③协助乙方处理与其他承包户发生的用路、用水、用电等纠纷；
          </p>
          <p style="text-indent: 2em">
            ④尊重乙方的生产经营自主权，不得干涉乙方依法进行正常的生产经营活动。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第五条 乙方的权利和义务
          </p>
          <p style="text-indent: 2em">1.乙方的权利</p>
          <p style="text-indent: 2em">
            ①依法享有集体建设用地使用、收益的权利，有权自主组织生产经营和处置产品；
          </p>
          <p style="text-indent: 2em">
            ②有权利用该承包集体建设用地上已有的开展农业生产所必需的水系、道路、构筑物等设施；
          </p>
          <p style="text-indent: 2em">
            ③合同到期后，有权在同等条件下优先续包；
          </p>
          <p style="text-indent: 2em">
            ④承包期间集体建设用地及周边土地被依法征收、征用、占用的，乙方应服从，但有权获得______________
            补偿。
          </p>
          <p style="text-indent: 2em">2.乙方的义务</p>
          <p style="text-indent: 2em">
            ①按合同约定及时接收该承包集体建设用地并向甲方足额支付承包费；
          </p>
          <p style="text-indent: 2em">
            ②承包期间，未经登记不得进行抵押及再流转；
          </p>
          <p style="text-indent: 2em">
            ③本合同到期，应提前一个月告知甲方是否续包。不续包的，应于合同到期日交回该流转土地；
          </p>
          <p style="text-indent: 2em">
            ④配合做好集体建设用地承包合同的审查备案工作；
          </p>
          <p style="text-indent: 2em">
            ⑤负责地上设施的维护和维修，合同到期后完整交付；
          </p>
          <p style="text-indent: 2em">
            ⑥为提高土地生产能力而进行设施改建，应征得甲方同意，需报有关部门批准的，按照相关规定办理；
          </p>
          <p style="text-indent: 2em">
            ⑦妥善管理该承包集体建设用地上未列入合同的水系、道路、构筑物等设施，如需使用或变动，须征得甲方和发包方同意；
          </p>
          <p style="text-indent: 2em">
            ⑧在法律法规政策和合同约定允许范围内保护和合理利用该承包集体建设用地，不得破坏农业综合生产能力和农业生态环境，不得撂荒土地、不得擅自改变土地用途、不得给土地造成永久性损害。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第六条 交付时和合同到期后地上附着物及相关设施的处理
          </p>
          <p style="text-indent: 2em">
            1.签订本合同并交付该集体资源性资产时，地上附着物及相关设施有：____________________________________________
            。
          </p>
          <p style="text-indent: 2em">
            2.合同到期时，由国家或地方财政直接补助形成的财产按国家和本市有关规定处理。
          </p>
          <p style="text-indent: 2em">
            3.乙方经营期间利用除财政补助外的资金构建的地上附着物及相关设备设施按下列方式处理：______________________
            。
          </p>
          <p style="text-indent: 2em">
            4.合同到期该集体资源性资产恢复原状等事项的处理：__________________________________________________
            。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第七条 合同变更、解除
          </p>
          <p style="text-indent: 2em">
            1.经协商一致，甲乙双方可对本合同进行变更、解除。
          </p>
          <p style="text-indent: 2em">
            2.当事人一方中途变更或解除合同的，应提前______日书面通知对方。
          </p>
          <p style="text-indent: 2em">
            3.合同有效期内，因不可抗力导致合同无法继续履行的，当事人可以解除合同；双方应按合同解除日期，结清合同履行期间相关费用。
          </p>
          <p style="text-indent: 2em">
            4.当事人一方违约导致合同无法履行的，另一方可以解除合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第八条 违约责任</p>
          <p style="text-indent: 2em">
            1.因变更或解除本合同使一方遭受损失的，除依法可免除责任的情形，应向守约方支付违约金________
            元。如果违约金不足以弥补守约方经济损失，违约方应据实赔偿。
          </p>
          <p style="text-indent: 2em">
            2.甲方逾期交付本合同约定的集体资源性资产，每延迟一天，按承包费用的______%承担违约金。
          </p>
          <p style="text-indent: 2em">
            3.乙方逾期支付承包费，每延迟一天，按应支付费用的______%承担违约金。
          </p>
          <p style="text-indent: 2em">
            4.甲方非法干预乙方生产经营活动，给乙方造成损失的，应予以赔偿。
          </p>
          <p style="text-indent: 2em">
            5.乙方私自在承包区域内取土或未经甲方书面同意私自改变土地用途和结构、破坏水利等基本设施或给土地造成永久性损害的，甲方有权解除合同，乙方应当赔偿对甲方造成的损失。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条 纠纷解决方式</p>
          <p style="text-indent: 2em">
            甲乙双方发生纠纷，可以协商解决，也可以请求乡（镇）人民政府等调解。当事人不愿协商、调解或者协商、调解不成的，可以向农村土地承包仲裁机构申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 特别约定</p>
          <p style="text-indent: 2em">
            1.承包合同生效后，不因承办人或者负责人的变动而变更或者解除，也不因集体经济组织的分立或者合并而变更或者解除。
          </p>
          <p style="text-indent: 2em">
            2.本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条其他约定</p>
          <p style="text-indent: 2em">
            __________________________________________________ 。
          </p>
          <p style="text-indent: 2em">
            本合同一式四份，双方盖章/签字有效。甲乙双方各执一份，乡（镇）农村综合产权交易服务站备案一份，__
            农村综合产权交易中心留存一份。经协商，决定______（提交/不提交）__
            农村综合产权交易中心鉴证。
          </p>
          <p style="font-weight: 700">甲方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：{{ detail.outname }}
          </p>
          <p>身份证号 （统一社会信用代码）：{{ detail.idnum }}</p>
          <p>联系方式：{{ detail.phone }}</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ detail.address }}
          </p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乙方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：____________________________________
          </p>
          <p>身份证号 （统一社会信用代码）：________________________</p>
          <p>联系方式：_______________</p>
          <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：_______________</p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乡镇农村综合产权交易服务站备案意见</p>
          <p>备案人：______________________</p>
          <p>备案日期：________年____月____日</p>
          <br />
          <p style="font-weight: 700">
            鉴 证 方（签字/签章）：{{ cityDetail.cityName }}农村综合产权交易中心
          </p>
          <P
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：____________________________________________</P
          >
          <P>联系方式：____________________________________________</P>
          <P>鉴证日期：________年____月____日</P>
        </div>
        <!-- c8.docx 农业生产设施设备 -->
        <div
          class="hetongBox"
          v-else-if="
            getOutPorjectType(detail.number) == '农业生产设施设备' ||
            getOutPorjectType(detail.number) == '农业生产设备设施'
          "
        >
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}生产性设施租赁合同
          </p>
          <br />
          <p>
            甲方（出租方）：<span style="text-decoration: underline">{{
              detail.outname
            }}</span>
          </p>
          <p>
            身份证号码：<span style="text-decoration: underline">{{
              detail.idnum
            }}</span>
          </p>
          <p>
            通讯地址：<span style="text-decoration: underline">{{
              detail.address
            }}</span>
          </p>
          <p>
            电话：<span style="text-decoration: underline">{{
              detail.phone
            }}</span>
          </p>
          <p>传真：<span>________________________________________</span></p>
          <p>
            邮箱：<span style="text-decoration: underline">{{
              detail.email
            }}</span>
          </p>
          <p>
            甲方（出租方）：<span
              >________________________________________</span
            >
          </p>
          <p>
            身份证号码：<span>________________________________________</span>
          </p>
          <p>通讯地址：<span>________________________________________</span></p>
          <p>电话：<span>________________________________________</span></p>
          <p>传真：<span>________________________________________</span></p>
          <p>邮箱：<span>________________________________________</span></p>
          <br />
          <p style="text-indent: 2em">
            甲乙双方本着平等互利的原则，经友好协商，现就生产性设施租赁事宜达成一致意见，根据合同法等相关法律法规，签订本合同，以咨信守：
          </p>
          <p style="font-weight: 700; text-indent: 2em">第一条 租赁设施</p>
          <p style="text-indent: 2em">乙方租赁甲方的生产性设施______________</p>
          <p style="font-weight: 700; text-indent: 2em">第二条 租赁期限</p>
          <p style="text-indent: 2em">
            租期期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，自
            <span style="text-decoration: underline">
              {{ detail.outstarttime }}
            </span>
            起至
            <span style="text-decoration: underline">
              {{ detail.outstoptime }}</span
            >
            。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第三条 租赁费用和交款办法及时间
          </p>
          <p style="text-indent: 2em">1、租赁费用</p>
          <p style="text-indent: 2em">
            租赁费用为人民币________元/月，每年合计________元
          </p>
          <p style="text-indent: 2em">2、交款办法及时间</p>
          <p style="text-indent: 2em">
            第一年租赁费________元，在____年____月____日前一次交清，以后每年____月____日前一次交清次年租赁费。如不按期交款，属于违约，视为乙方自动终止合同。
          </p>
          <p style="text-indent: 2em">甲方开户行：________________________</p>
          <p style="text-indent: 2em">户名__________</p>
          <p style="text-indent: 2em">账号：__________</p>
          <p style="font-weight: 700; text-indent: 2em">第四条 权利义务</p>
          <p style="text-indent: 2em">(一) 甲方权利与义务</p>
          <p style="text-indent: 2em">
            1.甲方负责将____________生产性设施给予乙方使用，甲方拥有被租赁的生产性设施所有权。
          </p>
          <p style="text-indent: 2em">
            2.因第三人主张权利，致使乙方不能对被租赁的生产性设施进行使用等，甲方必须协助调解处理，确保在租赁期限内无其他集体或个人对乙方提出任何异议，如果出现上述情况由甲方负责处理，与乙方无关，如甲方处理不当而给乙方造成了经济损失，由甲方负责赔偿。
          </p>
          <p style="text-indent: 2em">
            3.甲方尽量为乙方提供经营管理的有利条件；配合乙方协调上下级及周围群众关系。
          </p>
          <p style="text-indent: 2em">
            4.甲方负责生产性设施的监督检查，督促乙方完成生产性设施的按时维修保养等，确保生产性设施正常运行。
          </p>
          <p style="text-indent: 2em">（二）乙方权利与义务</p>
          <p style="text-indent: 2em">
            1.乙方在租赁期内拥有该生产性设施的使用权，甲方不得随意干扰其正常使用。除特殊情况外，甲方不得停止租赁，如果甲方未经乙方同意而擅自停止服务，应承担违约赔偿责任。
          </p>
          <p style="text-indent: 2em">
            2.在租赁期内，乙方不得随意停止租赁，乙方确因工作变动或其他原因，不愿再租赁，必须提前1个月通知甲方，否则，视为继续租赁。
          </p>
          <p style="text-indent: 2em">
            3.在租赁期间，乙方不得私自转包他人，必须征得甲方书面同意，方可转包他人，否则，终止合同。
          </p>
          <p style="text-indent: 2em">
            4.乙方必须按照约定的时间节点缴纳租赁费用，如无特殊原因，不能按时缴纳，视为不履行合同，终止合同。
          </p>
          <p style="text-indent: 2em">
            5.在租赁期内，乙方对生产性设施的正常运行、管理、维护负责，并做好设备的日常维修、保养，使设备保持良好状态，并承担所有的维修、保养费用。同时，甲方需要使用其设施时，必须征得乙方同意后，方可使用。
          </p>
          <p style="text-indent: 2em">
            6.租赁期满，乙方必须对生产性设施维修整治，待修缮完毕后，经现场认定后交予甲方，甲方不能故意刁难，无理拒收。同时，如乙方需要延长租期的，应在租赁时间届满前1月内，与甲方签订续约合同。
          </p>
          <p style="text-indent: 2em">
            7.乙方要严格执行甲方或当地政府等编制的防汛抗旱预案、用水计划，以及上级或同级确定的科研等项目要求，并无条件地服从各级的防汛抗旱、用水调度等的需要，确保农业灌慨，否则，终止合同。
          </p>
          <p style="text-indent: 2em">
            8.乙方在生产经营中，应严格遵守法律、法规及有关政策，办理各种合法证件，自觉交纳各种税与费，接受各职能部门的检查与监督。一旦被有关职能部门查处乙方具有违法、违规、违纪等行为，甲方将视其情节轻重，限期整改或终止合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第五条 安全与环保</p>
          <p style="text-indent: 2em">
            1 .乙方必须安排专人使用和管理被租赁的生产性设施，并遵照执行行业主管部门颁发实施的有关安全生产的法律、法规、规范标准及各项规定。
          </p>
          <p style="text-indent: 2em">
            2 .如发生安全事故，乙方必须立即以最快捷的方式告知甲方，积极组织人员全力救险，并向有关部门进行报告。
          </p>
          <p style="text-indent: 2em">
            3 .由于乙方原因造成的安全事故，由乙方自行承担相关责任，且所造成甲方的财产损失由乙方承担相应的赔偿责任，造成人员伤亡的，乙方应按国家有关规定对伤亡人员或家属进行经济赔偿，并主动处理好善后工作。
          </p>
          <p style="text-indent: 2em">
            4 .凡是由于乙方管理及自身预防措施不力造成的安全事故、环境污染等安全环保问题，所引起的相关责任及事后善后处理，均由乙方自行承担，因此给甲方造成的经济损失由乙方负责赔偿，甲方可追究乙方责任。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第六条 违约责任</p>
          <p style="text-indent: 2em">
            1.本合同一经签订，即生效。合同在履行期间，除国家政策性变化或大的调整不得不终止合同外，双方不得无故终止，如甲方终止合同，应退还当年租赁费，并承担乙方当年生产投资的直接费用，如果乙方终止合同，不影响租赁费的缴纳，并向甲方支付违约金____元。
          </p>
          <p style="text-indent: 2em">
            2.乙方不按期缴纳租赁费，应向甲方支付每天3‰的滞纳金，特殊情况最多不延迟两个月，超过两个月按终止合同处理。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第七条　合同变更</p>
          <p style="text-indent: 2em">
            经双方协商一致，可签订书面协议对本合同进行变更，该书面协议作为本合同的组成部分，与本合同具有同等法律效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第八条　不可抗力</p>
          <p style="text-indent: 2em">
            1、本合同所称不可抗力是指在合同履行期间发生的合同当事人不能预见、不能避免和不能克服的客观情况。不可抗力可以是自然原因酿成的，或是人为的、社会因素引起的，也可以是意外事件。如地震、水灾、旱灾、战争、政府禁令、罢工、车祸等。
          </p>
          <p style="text-indent: 2em">
            2、如因不可抗力事件的发生导致合同无法履行时，遇不可抗力的一方应及时将事故情况告知另一方，并应在______天内，提供事故详情及合同不能履行或者需要延期履行的书面资料，双方认可后协商终止合同或暂时延迟合同的履行。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第九条　通知</p>
          <p style="text-indent: 2em">
            1、根据本合同需要发出的全部通知以及双方的往来文件及与本合同有关的通知和要求等，必须用书面形式，可采用书信、快递、当面送交等方式传递。
          </p>
          <p style="text-indent: 2em">
            2、甲、乙双方承诺以本合同首部的通讯地址、联系方式为有效通讯地址、联系方式；本合同首部的通讯地址、联系方式变更的，变更方应及时通知对方，否则，应当自行承担由此造成的一切不利后果。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条 争议解决</p>
          <p style="text-indent: 2em">
            双方在履行合同中发生争议的，应协商解决；协商不成的，可依法提起诉讼。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条 合同生效</p>
          <p style="text-indent: 2em">
            本合同自双方签订之日起生效，本合同一式四份，双方各执一份，乡镇农村综合产权交易服务站备案一份，__
            县农村综合产权交易中心留存一份，每份具有同等法律效力。
          </p>
          <p style="text-indent: 2em">
            经协商，决定(提交/不提交)____县农村综合产权交易中心签证。
          </p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">甲方：</p>
            <p style="width: 50%">乙方：</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">法定代表人/委托代理人：</p>
            <p style="width: 50%">法定代表人/委托代理人：</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">__________年__ 月__ 日</p>
            <p style="width: 50%">__________年__ 月__ 日</p>
          </div>
        </div>
        <!-- c9.docx 农村小微工程 -->
        <div
          class="hetongBox"
          v-else-if="getOutPorjectType(detail.number) == '农村小微工程'"
        >
          <p style="text-align: center">农村小微工程合同书</p>
          <br />
          <p>
            委托方：_______________________________________________（以下简称甲方）
          </p>
          <p>
            承揽方：_______________________________________________（以下简称乙方）
          </p>
          <p style="text-indent: 2em">
            经友好协商，本着相互尊重原则，甲方委托乙方制作业务，为明确双方责任，确保完成任务，共同信守合约，经双方协商一致，特签定如下协议，以供双方共同遵守执行。
          </p>
          <p>一、主要要求：</p>
          <p>
            （一）项目名称：____________________________________________________
          </p>
          <p>
            （二）项目地点：_____________________________________________________
          </p>
          <p>
            （三）其它内容：_____________________________________________________
          </p>
          <p>
            （四）预算总造价：__________________________________________________
          </p>
          <p>二、期限：</p>
          <p style="text-indent: 2em">
            本合同内容从_____年____月____日开始到_____年____月____日之前完毕。
          </p>
          <p>三、结算方式：</p>
          <p>
            1．本合同签定之日，甲方向乙方预付总造价___%，暨人民币______元，余款___%在工程结束后壹拾伍天内一次性结清，尾款___%作为质量保证金半年后结清。
          </p>
          <p>
            2．合同操作期间，合同外增加内容，甲、乙双方认可后，甲方应先支会增加部分款项的50%，余额50%在验收合格后一次性付清。
          </p>
          <p>四、施工、拆除与设计变更：</p>
          <p>1．乙方根据要求组织制作，并达到合格标准。</p>
          <p>2．施工过程中甲方应积极配合乙方现场的协调工作。</p>
          <p>五、工程交验与保修：</p>
          <p>
            1．乙方在工程结束后通知甲方两天内验收。如逾期不验收，甲方使用的，则乙方做验收合格通过。
          </p>
          <p>
            2．验收时，如发现甲方责任而造成的质量问题，提出返工或补修意见时，乙方在规定期限内完成，收取相应工本费。如乙方造成质量问题，则由乙方免费更换。
          </p>
          <p>3．工程保修期为1年（人为及不可抵拒的自然灾害除外）。</p>
          <p>六、工程负责人和工伤事故：</p>
          <p>
            1、甲方委派 为驻现场负责人，并与乙方委派
            的为现场负责人，共同履行本合同的各项规定。
          </p>
          <p>
            2、乙方应教育工人，严格要求遵守操作规程，做好防火、防盗工作，并遵守工地现场的有关规定，在施工中发生工伤事故造成的损失，由乙方负责。
          </p>
          <p>七、特别说明：</p>
          <p>
            该项目现场如需要用电源应安排在离产品1米范围内。现场安装定位及其他涉及安装需要协调之事由甲方解决；
          </p>
          <p>八、其他条款：</p>
          <p>
            1．委托方在审定承办设计内容时，请仔细审核项目中的每一细节内容，审定后签字或认可说明，经确认后发生差错，由委托方承担所有责任及全部内容。
          </p>
          <p>
            2．合同签定后，如有单方面违约，全部责任将有违约方承担。任何一方如需要变更本合同或其他特殊要求，应双方共同协商一致后。另行签约补充合同。
          </p>
          <p>3．合同附件</p>
          <p>1. ____________________________________________________________</p>
          <p>2. ____________________________________________________________</p>
          <p>九、争议解决：</p>
          <p>
            本合同执行中，如发生争议，双方应尽力协商解决，如协商不成，任何一方都可向有管辖权的仲裁机构，进行仲裁或向法院提起申诉。
          </p>
          <p>1．合同附件及补充合同与本合同具有法律同等效力。</p>
          <p>2．本合同一式肆份，双方签字盖章后生效。</p>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">甲方：</p>
            <p style="width: 50%">乙方：</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">法定代表人/委托代理人：</p>
            <p style="width: 50%">法定代表人/委托代理人：</p>
          </div>
          <div style="width: 100%; display: flex; flex-flow: row nowarp">
            <p style="width: 50%">__________年__ 月__ 日</p>
            <p style="width: 50%">__________年__ 月__ 日</p>
          </div>
        </div>
        <!-- t1.docx 通用合同 -->
        <div class="hetongBox" v-else>
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            {{ cityDetail.cityName }}农村集体经营性资产租赁合同
          </p>
          <p style="font-size: 22px; text-align: center">
            （适用于村集体经济组织租赁机械设备）
          </p>
          <p style="font-weight: 700">
            出租人：
            <span style="text-decoration: underline">{{ detail.outname }}</span>
          </p>
          <p>法定代表人：_______________________</p>
          <p style="font-weight: 700">
            承租人：<span>________________________________________</span>
          </p>
          <p>法定代表人：_______________________</p>
          <p style="font-weight: 700">保证人：_______________________</p>
          <p>法定代表人：_______________________</p>
          <p style="text-indent: 2em">
            为明确出租人、承租人、保证担保人的权利和义务，特依据《中华人民共和国合同法》、《中华人民共和国担保法》及有关法律法规，遵循平等、自愿、公平和诚信的原则，就____机械设备租赁事宜协商一致，订立本合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第一条 设备名称、型号、规格及数量
          </p>
          <p style="text-indent: 2em">
            ________________________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">第二条　租赁期限</p>
          <p style="text-indent: 2em">
            设备租赁期限为
            <span style="text-decoration: underline">{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}</span>
            年，即自
            <span style="text-decoration: underline">{{
              detail.outstarttime
            }}</span>
            起至
            <span style="text-decoration: underline">{{
              detail.outstoptime
            }}</span>
            。
          </p>
          <p style="text-indent: 2em">
            承租人需要延长租期的，应在合同届满前______日内，与出租人协商重新签订合同。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第三条　租金及支付</p>
          <p style="text-indent: 2em">
            1.租金及计算：租金______元／月；实际使用不足一个月部分按照月租费÷30天×实际使用天数计算。
          </p>
          <p style="text-indent: 2em">
            2.租金支付：租赁费用按月计算。每月的______日支付下月租赁费。
          </p>
          <p style="text-indent: 2em">
            3.租金变动：____________________________________
          </p>
          <p style="text-indent: 2em">4．租赁计费起止时间</p>
          <p style="text-indent: 2em">
            （1）______年____月____日为本次设备租赁的计费开始时间，如果设备交给承租人没有使用的，租赁费照常计算。
          </p>
          <p style="text-indent: 2em">
            （2）机械退租时，承租人必须向出租人发出书面通知，出租人接到书面通知并对设备进行检验，除正常损耗没有其他损坏的，予以退租；如有其他损坏，承租人赔偿损失后予以退租。
          </p>
          <p style="text-indent: 2em">
            5.机械的进退场费采取以下第________种方式：
          </p>
          <p style="text-indent: 2em">
            ①机械的进出场运输由出租人负责办理，承租人协助装卸车。机械的进出场费全部由承租人承担。
          </p>
          <p style="text-indent: 2em">
            ②其他方式：___________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            特别提醒：每届村集体经济组织理事会或代行职能的村民委员会收取的承包费用，不得超过本届村集体经济组织理事会或代行职能的村民委员会任期的剩余期限。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第四条　工程项目、工作内容和施工地点
          </p>
          <p style="text-indent: 2em">
            1.工程项目：____________________________________
          </p>
          <p style="text-indent: 2em">
            2.工作内容：____________________________________
          </p>
          <p style="text-indent: 2em">
            3.施工地点：____________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第五条　租赁方式及所有权
          </p>
          <p style="text-indent: 2em">1.租赁方式：</p>
          <p style="text-indent: 2em">
            ①本设备的租赁由出租人配备操作人员。负责设备的操作和维护保养工作；
          </p>
          <p style="text-indent: 2em">②其他方式：____________________。</p>
          <p style="text-indent: 2em">
            2.租赁设备的所有权：本合同项下租赁设备的所有权属于出租人，承租人对租赁机械只享有租赁期间的使用权。
          </p>
          <p style="text-indent: 2em">
            3.未经出租人书面同意，承租人不得在设备上随意增加或减少部件，也不得将设备转让、转租、抵押或做其他任何处置。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第六条　押金</p>
          <p style="text-indent: 2em">
            经双方协商，出租人收取承租人押金________元，承租人应于本合同签订之日交纳。承租人交纳后办理提货手续。租赁期间不得以押金抵作租金；租赁期满，扣除应付租赁物资缺损赔偿金后，押金余额退还承租人。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第七条　设备验收、安装、调试与管理
          </p>
          <p style="text-indent: 2em">
            设备的验收、安装、调试、使用、保养、维修管理等由____负责。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第八条　租赁机械的毁损和灭失
          </p>
          <p style="text-indent: 2em">
            1.承租人承担在租赁期内发生的承租方责任租赁机械的毁损（正常损耗不在此内）和灭失的风险。由不可抗力的原因不能履行合同或造成损失时双方根实际情况协商解决。
          </p>
          <p style="text-indent: 2em">
            2.在租赁机械发生毁损和灭失时，承租人应立即通知出租人，出租人有权选择下列第________种方式，由承租人负责处理并承担其一切费用。
          </p>
          <p style="text-indent: 2em">
            ①将租赁机械复原或修理至完全能正常使用的状态。
          </p>
          <p style="text-indent: 2em">
            ②更换与租赁机械同等型号、性能的部件或配件使其能正常使用。
          </p>
          <p style="text-indent: 2em">
            ③当租赁机械毁损、灭失至无法修理的程度时，承租人应按照________元的价格赔偿出租人。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第九条　技术安全要求：
          </p>
          <p style="text-indent: 2em">
            ______________________________________________________
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十条　担保</p>
          <p style="text-indent: 2em">
            ______同意作为承租人的保证人，负责承租人切实履行本合同各条款规定，如承租人在合同期内不能承担合同中规定的经济责任时，保证人应向出租人支付承租人余下的各期租金、违约金和其它损失。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十一条　义务和责任</p>
          <p style="text-indent: 2em">1.出租人的义务和责任</p>
          <p style="text-indent: 2em">
            ①密切配合承租方的施工生产，满足承租人施工要求。服从承租人施工人员的施工安排，但有权拒绝承租人的违章指挥。
          </p>
          <p style="text-indent: 2em">
            ②负责提供设备及设备操作方法，配合承租人要求提供操作人员、维护人员并提供日常维护保养和故障的处理，按照承租方需求负责操作人员的工资及设备维修配件。
          </p>
          <p style="text-indent: 2em">
            ③________________________________________________。
          </p>
          <p style="text-indent: 2em">2.承租人的义务和责任</p>
          <p style="text-indent: 2em">
            ①负责工作期间租赁机械和操作司机的安全，严禁违章指挥，如违章指挥造成机械和人员的损伤，承租人承担一切责任损失。
          </p>
          <p style="text-indent: 2em">
            ②按照合同约定提供出租人操作司机的食宿，承担司机加班费及施工补助。
          </p>
          <p style="text-indent: 2em">
            ③负责租赁设备的进场签认，负责租费的及时支付。
          </p>
          <p style="text-indent: 2em">
            ④负责租赁期间设备保护及看守，确保安全使用。
          </p>
          <p style="text-indent: 2em">
            ⑤提供合格的燃油及润滑油，保障机械正常运行。
          </p>
          <p style="text-indent: 2em">
            ⑥租赁期间，按照合同约定，若出租人购买零配件及材料，承租人应提供交通方便，所需费用由_______方承担。
          </p>
          <p style="text-indent: 2em">
            ⑦负责租赁机械进出场运费，负责运输安全，承担运输费用及保险费。
          </p>
          <p style="text-indent: 2em">
            ⑧_____________________________________________________。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十二条　违约责任</p>
          <p style="text-indent: 2em">
            1．未经出租人书面同意，承租人在设备上随意增加或减少部件的，承租人应将设备恢复原状，并向出租人支付违约金________元。
          </p>
          <p style="text-indent: 2em">
            2．未经出租人书面同意，承租人将设备转让、转租、抵押或做其他任何处分的，应向出租人支付违约金________元，并赔偿给出租人造成的损失。
          </p>
          <p style="text-indent: 2em">
            3．承租人延迟支付设备进场费或者延迟预付机械租费时，出租人设备将延迟进场、延期使用。
          </p>
          <p style="text-indent: 2em">
            4．承租人如不按期支付租赁费用或违反本合同的任何条款时，出租人有权采取下列措施：
          </p>
          <p style="text-indent: 2em">
            ①要求承租人及时付清租费和其他费用，并要求承租人赔偿出租人的损失。
          </p>
          <p style="text-indent: 2em">
            ②解除本合同，收回租赁设备，并要求承租人赔偿出租人的一切损失。
          </p>
          <p style="text-indent: 2em">
            5.各方保证对从其他方取得且无法自公开渠道获得的商业秘密（技术信息、经营信息及其他商业秘密）予以保密。未经该商业秘密的原提供方同意，不得向任何第三方泄露该商业秘密的全部或部分内容。但法律、法规另有规定或另有约定的除外。一方违反保密义务的，应向对方支付违约金_____元，并赔偿给对方造成的损失。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十三条　合同变更</p>
          <p style="text-indent: 2em">
            1．在租赁期间，出租人如将租赁物资所有权转移给第三人，应正式通知承租人，租赁物资新的所有权人即成为本合同的当然出租人。
          </p>
          <p style="text-indent: 2em">
            2．经各方协商一致，可签订书面协议对本合同进行变更，该书面协议作为本合同的组成部分，与本合同具有同等法律效力。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十四条　声明及承诺</p>
          <p style="text-indent: 2em">
            1.出租人、承租人签署和履行本合同所需的一切手续均已办妥并合法有效。
          </p>
          <p style="text-indent: 2em">
            2.在签署本合同时，任何法院、仲裁机构、行政机关或监管机构均未作出任何足以对出租方履行本合同产生重大不利影响的判决、裁定、裁决或具体行政行为。
          </p>
          <p style="text-indent: 2em">
            3.出租人、承租人为签署本合同所需的内部授权程序均已完成。本合同生效后即对合同各方具有法律约束力。
          </p>
          <p style="text-indent: 2em">
            4.根据本合同需要发出的全部通知以及各方的往来文件及与本合同有关的通知和要求等，均须用书面形式（书信、快递、当面送交等方式）传递。
          </p>
          <p style="text-indent: 2em">
            5.各方承诺以本合同首部的通讯地址、联系方式为有效通讯地址、联系方式；本合同首部的通讯地址、联系方式变更的，变更方应及时通知对方，否则，应当自行承担由此造成的一切不利后果。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十五条　不可抗力</p>
          <p style="text-indent: 2em">
            1．本合同所称不可抗力是指在协议履行期间发生的合同当事人不能预见、不能避免和不能克服的客观情况。不可抗力可以是自然原因酿成的，或是人为的、社会因素引起的，也可以是意外事件。如地震、水灾、旱灾、战争、政府禁令、罢工、车祸等。
          </p>
          <p style="text-indent: 2em">
            2．如因不可抗力事件的发生导致协议无法履行时，遇不可抗力的一方应及时将事故情况告知另一方，并应在______天内，提供事故详情及合同不能履行或者需要延期履行的书面资料，双方认可后协商终止合同或暂时延迟合同的履行。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第十六条　纠纷解决方式
          </p>
          <p style="text-indent: 2em">
            各方在履行合同中发生争议的，可以协商解决，也可以请求乡（镇）人民政府等调解。当事人不愿协商、调解或者协商、调解不成的，可以向农村土地承包仲裁委员会申请仲裁，也可以直接向人民法院起诉。
          </p>
          <p style="font-weight: 700; text-indent: 2em">
            第十七条　其他约定事项
          </p>
          <p style="text-indent: 2em">
            1.出租人机械因故障停机，应在4小时内恢复使用，如果超过4小时但不足一个工作日，免收租金额为月租费／30，如果一个月中因故障停机天数累加超过五个工作日，免收半个月租金，如果一个月中因故障停机天数累加超过十个工作日，免收全月租金。
          </p>
          <p style="text-indent: 2em">
            2.出租人未按时进入工地、未按质量、数量提供机械应________________________________________________。
          </p>
          <p style="text-indent: 2em">
            3.出租人机械或服务不能满足承租人要求，承租人有权要求赔偿损失，直至解除合同。
          </p>
          <p style="text-indent: 2em">
            4.
            本合同未尽事宜，甲乙双方另行签定书面补充协议，补充协议与本合同具有同等效力。
          </p>
          <p style="text-indent: 2em">
            5．____________________________________________。
          </p>
          <p style="font-weight: 700; text-indent: 2em">第十八条　合同解释</p>
          <p style="text-indent: 2em">
            本合同的理解与解释应依据合同目的和文本原义进行，本合同的标题仅是为了阅读方便而设，不应影响本合同的解释。
          </p>
          <p style="text-indent: 2em">
            本合同一式四份，双方盖章/签字有效。甲乙双方各执一份，乡(镇）农村综合产权交易服务站备案一份，农村综合产权交易中心留存一份。经协商，决定____（提交/不提交）农村综合产权交易中心鉴证。
          </p>
          <br />
          <br />
          <br />
          <p style="font-weight: 700">甲方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：{{ detail.outname }}
          </p>
          <p>身份证号 （统一社会信用代码）：{{ detail.idnum }}</p>
          <p>联系方式：{{ detail.phone }}</p>
          <p>
            地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{ detail.address }}
          </p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乙方（盖章/签字）：</p>
          <p>
            承包方代表、自然人、法定代表人或主要负责人姓名：____________________________________
          </p>
          <p>身份证号 （统一社会信用代码）：________________________</p>
          <p>联系方式：_______________</p>
          <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：_______________</p>
          <p style="text-align: right">________年____月____日</p>
          <p style="font-weight: 700">乡镇农村综合产权交易服务站备案意见</p>
          <p>备案人：______________________</p>
          <p>备案日期：________年____月____日</p>
          <br />
          <p style="font-weight: 700">
            鉴 证 方（签字/签章）：{{ cityDetail.cityName }}农村综合产权交易中心
          </p>
          <P
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：____________________________________________</P
          >
          <P>联系方式：____________________________________________</P>
          <P>鉴证日期：________年____月____日</P>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTypeList } from '@/api/交易项目详情'
import { getNewsDetail, getNewslist } from '../api/mian'
import { cityDetail } from '../util/mainOption'
import { getProList } from '../api/交易项目'

export default {
  props: ["detail", "backCardInfo"],
  data () {
    return {
      getDetailActive: 1, //项目模块展示
      showPhone: false,
      showRegisternum: false,
      dictList: {
        // 转出方类别
        "out_person_type": [],
        // 招标方式
        "invitation_type": [],
        // 单位
        "area_unit": [],
        // 农地权属
        "land_type": [],
        // 承包方式
        "job_type": [],
        // 项目类型
        "project_area_type": [],
        // 土地性质
        "tdxz_type": [],
        // 转出方式
        "out_type": [],
        // 支付方式
        "pay_type": [],
        // 出价幅度
        "floating_price": [],
        // 是否再次转出
        "yes_no": [],
      },
      // 收费标准
      chargeStandard: "",
      // 报名方式 html
      applyWay: "",
      // 产权传出类型
      outProjectTypeList: []
    }
  },
  mounted () {
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
        console.log("报名方式新闻详情", this.applyWay)
      })
    })
    if (cityDetail.chargeStandard) {
      getNewslist({
        number: '020',
        pageSize: 10,
        pageNum: 1,
        deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
      }).then(res => {
        res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
          console.log("收费标准新闻详情", res.data.data)
          this.chargeStandard = res.data.data.content
        })
      })
    }
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then(res => {
        this.dictList[dictTitle] = res.data.data
      })
    }
    getProList({ type: 2 }).then(res => {
      console.log("产权传出类型", res)
      this.outProjectTypeList = res.data.data
    })
  },
  methods: {
    bigWrite (num) {
      let max = 999999999999.99
      if (Number(num) > max) return "超过函数可接受最大值"
      let unitList = [
        "",
        "拾",
        "佰",
        "仟",
      ]
      let numberList = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖",
      ]
      let decimals = num.toString().split(".")[1]
      num = num.toString().split(".")[0]
      let numToStringRes = ""
      let numSliceList =
        console.log("num.length", num.length)
      if (num.length > 8) {
        numSliceList = {
          "亿": "",
          "万": "",
          "元": "",
        }
        numSliceList["亿"] = num.slice(0, num.length - 8)
        numSliceList["万"] = num.slice(num.length - 8, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else if (num.length > 4) {
        numSliceList = {
          "万": "",
          "元": "",
        }
        numSliceList["万"] = num.slice(0, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else {
        numSliceList = {
          "元": "",
        }
        numSliceList["元"] = num
      }
      for (let j = 0; j < Object.keys(numSliceList).length; j++) {
        num = Number(numSliceList[Object.keys(numSliceList)[j]])
        let stringRes = ""
        for (let i = 0; i < unitList.length; i++) {
          if (num == 0) {
            break
          }
          let yu = Math.floor(num % 10)
          stringRes = (numberList[yu] == "零" ? numberList[yu] : (numberList[yu] + unitList[i])) + stringRes
          num = Math.floor(num / 10)
        }
        while (true) {
          if (stringRes.indexOf("零零") < 0) {
            break
          }

          stringRes = stringRes.replace("零零", "零")
        }
        if (stringRes.slice(stringRes.length - 1) == "零") {
          stringRes = stringRes.substring(0, stringRes.length - 1)
        }
        stringRes += Object.keys(numSliceList)[j]
        numToStringRes += stringRes
      }
      if (decimals.length > 0 && Number(decimals) != 0) {
        decimals = Number(decimals)
        numToStringRes += (numberList[Math.floor(decimals / 10)] ? numberList[Math.floor(decimals / 10)] + "角" : "零") + (numberList[Math.floor(Number(decimals % 10))] == "零" ? numberList[Math.floor(Number(decimals % 10))] + "分" : "")
      }
      return numToStringRes
    },
    getOutPorjectType (num) {
      let typeObj = this.outProjectTypeList.find(item => item.code == num)
      return typeObj ? typeObj.name : ""
    },
    checkShowPhone () {
      this.showPhone = !this.showPhone
    },
    checkShowRegisternum () {
      this.showRegisternum = !this.showRegisternum
    },
    // 获取字典值
    getDictValue (value, dictTitle) {
      if ((value !== 0 && value !== '0') && !value) return "暂无"
      return this.dictList[dictTitle].find((item) => item.dictValue == value) ? this.dictList[dictTitle].find((item) => item.dictValue == value).dictLabel : "暂无"
    },
  },
}
</script>

<style lang="scss" scoped>
.fengexian1 {
  margin: 30px 0 50px 0;
}

.el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.conent > div {
  margin: 10px 0;
}
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
  cursor: pointer;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
  cursor: pointer;
}
.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
.tableBox {
  display: flex;
}
.left {
  width: 100%;
  text-align: left;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
}
.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
  width: 50%;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tet2 {
  padding: 20px 20px;
  width: 685px;
  max-width: 685px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}
table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}
.hetongBox {
  width: 100%;
  height: auto;
  text-align: start;
  p {
    line-height: 2;
  }
}
</style>